import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { ExcelLocationImport_ShellService } from './ExcelLocationImport.shell.service';
import { ExcelLocationImport_OperationService } from './ExcelLocationImport.operation.service';
import { ExcelLocationImport_DatasourceService } from './ExcelLocationImport.datasource.index';
import { ExcelLocationImport_FlowService } from './ExcelLocationImport.flow.index';
import { ExcelLocationImport_ReportService } from './ExcelLocationImport.report.index';
import { ExcelLocationImport_LocalizationService } from './ExcelLocationImport.localization.service';
import { ExcelLocationImport_excel_location_import_grid_ComponentContextService } from './ExcelLocationImport.excel_location_import_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './ExcelLocationImport.frontend.types'
import { $frontendTypes as $types} from './ExcelLocationImport.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { ExcelLocationImport_location_type_dd_singleComponent } from './ExcelLocationImport.location_type_dd_single.component'
import { ExcelLocationImport_warehouses_dd_singleComponent } from './ExcelLocationImport.warehouses_dd_single.component'
import { ExcelLocationImport_zones_dd_singleComponent } from './ExcelLocationImport.zones_dd_single.component'
import { ExcelLocationImport_materialstatuses_dd_singleComponent } from './ExcelLocationImport.materialstatuses_dd_single.component'
import { ExcelLocationImport_yn_dd_singleComponent } from './ExcelLocationImport.yn_dd_single.component'
import { ExcelLocationImport_measurement_units_dd_singleComponent } from './ExcelLocationImport.measurement_units_dd_single.component'
import { ExcelLocationImport_mixing_rule_dd_singleComponent } from './ExcelLocationImport.mixing_rule_dd_single.component'
import { ExcelLocationImport_storage_category_dd_singleComponent } from './ExcelLocationImport.storage_category_dd_single.component'


interface IExcelLocationImport_excel_location_import_gridComponentEntity {
  Id?: number, AllocationSequence?: number, ChildFootprint?: number, ChildStackHeight?: number, DimensionUomId?: number, EligibleForAllocation?: boolean, Height?: number, IsLoose?: boolean, IsPrimaryPick?: boolean, Length?: number, MixingRuleId?: number, Name?: string, ParentId?: number, PickSequence?: number, PutAwaySequence?: number, SkipValidationRules?: boolean, StatusId?: number, StorageCategoryId?: number, TypeId?: number, WarehouseId?: number, WeightCapacity?: number, WeightUomId?: number, Width?: number, Warehouse?: { Name?: string }, Type?: { Name?: string }, ParentLocationContainer?: { Name?: string }, Status?: { Name?: string }, DimensionsUom?: { Short_name?: string }, WeightUom?: { Short_name?: string }, MixingRule?: { Name?: string }, StorageCategory?: { LookupCode?: string }}



class ExcelLocationImport_excel_location_import_gridComponentRowModel extends GridRowModel {
  grid: ExcelLocationImport_excel_location_import_gridComponent;
  entity: IExcelLocationImport_excel_location_import_gridComponentEntity;

  vars: { warehouseId?: number } = { };


 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    type_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    warehouse_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    parent_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    name_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    status_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    eligible_for_allocation_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    is_loose_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    is_primary_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    length_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    width_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    height_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    dimensions_uom_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    weight_capacity_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    weight_uom_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    child_footprint_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    child_stack_height_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    skip_validation_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    allocation_sequence_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    pick_sequence_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    putaway_sequence_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    mixing_restrictions_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    storage_category_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
  });

  override cells = {
    Id: null,
    import_status: null,
    row_count: null,
    error: null,
    type: null,
    warehouse: null,
    parent: null,
    name: null,
    status: null,
    eligible_for_allocation: null,
    is_loose: null,
    is_primary: null,
    length: null,
    width: null,
    height: null,
    dimensions_uom: null,
    weight_capacity: null,
    weight_uom: null,
    child_footprint: null,
    child_stack_height: null,
    skip_validation: null,
    allocation_sequence: null,
    pick_sequence: null,
    putaway_sequence: null,
    mixing_restrictions: null,
    storage_category: null,
  }

  get $fields_parent_selector_inParams_warehouseId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = $utils.isDefined($row.entity.WarehouseId) ? $row.entity.WarehouseId : $row.vars.warehouseId;
    
    return expr;
  }
  get $fields_dimensions_uom_selector_inParams_typeId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = 1;
    
    return expr;
  }
  get $fields_weight_uom_selector_inParams_typeId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = 3;
    
    return expr;
  }


  constructor(
    grid: ExcelLocationImport_excel_location_import_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: ExcelLocationImport_ShellService,
private $datasources: ExcelLocationImport_DatasourceService,
private $flows: ExcelLocationImport_FlowService,
private $reports: ExcelLocationImport_ReportService,
private $localization: ExcelLocationImport_LocalizationService,
private $operations: ExcelLocationImport_OperationService,
private $logger: CleanupLoggerService,
private $context: ExcelLocationImport_excel_location_import_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.Id = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Id,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.import_status = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.import_status,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.row_count = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.row_count,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.error = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.error,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.type = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.type,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['type_edit'] as DatexFormControl, 
        null, null,
        true,
        false,
        '', null)
      );
    
    this.cells.warehouse = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.warehouse,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['warehouse_edit'] as DatexFormControl, 
        null, null,
        true,
        false,
        '', null)
      );
    
    this.cells.parent = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.parent,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['parent_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.name,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['name_edit'] as DatexFormControl, null, true, false, '', null)
      );
    
    this.cells.status = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.status,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['status_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.eligible_for_allocation = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.eligible_for_allocation,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['eligible_for_allocation_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.is_loose = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.is_loose,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['is_loose_edit'] as DatexFormControl, 
        null, null,
        true,
        false,
        '', null)
      );
    
    this.cells.is_primary = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.is_primary,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['is_primary_edit'] as DatexFormControl, 
        null, null,
        true,
        false,
        '', null)
      );
    
    this.cells.length = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.length,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['length_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.width = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.width,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['width_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.height = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.height,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['height_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.dimensions_uom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.dimensions_uom,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['dimensions_uom_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.weight_capacity = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.weight_capacity,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['weight_capacity_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.weight_uom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.weight_uom,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['weight_uom_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.child_footprint = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.child_footprint,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['child_footprint_edit'] as DatexFormControl, null, false, false, '0', '', null)
      );
    
    this.cells.child_stack_height = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.child_stack_height,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['child_stack_height_edit'] as DatexFormControl, null, false, false, '0', '', null)
      );
    
    this.cells.skip_validation = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.skip_validation,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['skip_validation_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.allocation_sequence = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.allocation_sequence,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['allocation_sequence_edit'] as DatexFormControl, null, false, false, '0', '', null)
      );
    
    this.cells.pick_sequence = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.pick_sequence,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['pick_sequence_edit'] as DatexFormControl, null, false, false, '0', '', null)
      );
    
    this.cells.putaway_sequence = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.putaway_sequence,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['putaway_sequence_edit'] as DatexFormControl, null, false, false, '0', '', null)
      );
    
    this.cells.mixing_restrictions = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.mixing_restrictions,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['mixing_restrictions_edit'] as DatexFormControl, 
        null, null,
        true,
        false,
        '', null)
      );
    
    this.cells.storage_category = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.storage_category,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['storage_category_edit'] as DatexFormControl, 
        null, null,
        true,
        false,
        '', null)
      );
    
    
    this.formGroup
      .controls['warehouse_edit']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_warehouse_change();
      });
  }

  async $initializeExisting(entity: IExcelLocationImport_excel_location_import_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IExcelLocationImport_excel_location_import_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
      await this.on_init_new_row();
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      warehouseId:  $grid.vars.warehouseId ,
    };
    const data = await this.$datasources.ExcelLocationImport.ds_location_import_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IExcelLocationImport_excel_location_import_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.Id.displayControl as TextModel).text = $row.entity.Id?.toString();
    (this.cells.type.displayControl as TextModel).text = $row.entity.Type?.Name;
    (this.cells.type.editControl as SelectBoxModel).reset($row.entity.TypeId);
    (this.cells.warehouse.displayControl as TextModel).text = $row.entity.Warehouse?.Name;
    (this.cells.warehouse.editControl as SelectBoxModel).reset($row.entity.WarehouseId);
    (this.cells.parent.displayControl as TextModel).text = $row.entity.ParentLocationContainer?.Name;
    (this.cells.parent.editControl as SelectBoxModel).reset($row.entity.ParentId);
    (this.cells.name.displayControl as TextModel).text = $row.entity?.Name;
    (this.cells.name.editControl as TextBoxModel).reset($row.entity?.Name);
    (this.cells.status.displayControl as TextModel).text = $row.entity.Status?.Name;
    (this.cells.status.editControl as SelectBoxModel).reset($row.entity.StatusId);
    (this.cells.eligible_for_allocation.displayControl as TextModel).text = ($row.entity.EligibleForAllocation == false ? 'N' : 'Y');
    (this.cells.eligible_for_allocation.editControl as SelectBoxModel).reset(($row.entity.EligibleForAllocation == false ? 'N' : 'Y'));
    (this.cells.is_loose.displayControl as TextModel).text = ($row.entity.IsLoose == true ? 'Y' : 'N');
    (this.cells.is_loose.editControl as SelectBoxModel).reset(($row.entity.IsLoose == true ? 'Y' : 'N'));
    (this.cells.is_primary.displayControl as TextModel).text = ($row.entity.IsPrimaryPick == true ? 'Y' : 'N');
    (this.cells.is_primary.editControl as SelectBoxModel).reset(($row.entity.IsPrimaryPick == true ? 'Y' : 'N'));
    (this.cells.length.displayControl as TextModel).text = $row.entity.Length?.toString();
    (this.cells.length.editControl as NumberBoxModel).reset($row.entity.Length);
    (this.cells.width.displayControl as TextModel).text = $row.entity.Width?.toString();
    (this.cells.width.editControl as NumberBoxModel).reset($row.entity.Width);
    (this.cells.height.displayControl as TextModel).text = $row.entity.Height?.toString();
    (this.cells.height.editControl as NumberBoxModel).reset($row.entity.Height);
    (this.cells.dimensions_uom.displayControl as TextModel).text = $row.entity.DimensionsUom?.Short_name;
    (this.cells.dimensions_uom.editControl as SelectBoxModel).reset($row.entity.DimensionUomId);
    (this.cells.weight_capacity.displayControl as TextModel).text = $row.entity.WeightCapacity?.toString();
    (this.cells.weight_capacity.editControl as NumberBoxModel).reset($row.entity.WeightCapacity);
    (this.cells.weight_uom.displayControl as TextModel).text = $row.entity.WeightUom?.Short_name;
    (this.cells.weight_uom.editControl as SelectBoxModel).reset($row.entity.WeightUomId);
    (this.cells.child_footprint.displayControl as TextModel).text = $row.entity.ChildFootprint?.toString();
    (this.cells.child_footprint.editControl as NumberBoxModel).reset($row.entity.ChildFootprint);
    (this.cells.child_stack_height.displayControl as TextModel).text = $row.entity.ChildStackHeight?.toString();
    (this.cells.child_stack_height.editControl as NumberBoxModel).reset($row.entity.ChildStackHeight);
    (this.cells.skip_validation.displayControl as TextModel).text = ($row.entity.SkipValidationRules == false ? 'N' : 'Y');
    (this.cells.skip_validation.editControl as SelectBoxModel).reset(($row.entity.SkipValidationRules == false ? 'N' : 'Y'));
    (this.cells.allocation_sequence.displayControl as TextModel).text = $row.entity.AllocationSequence?.toString();
    (this.cells.allocation_sequence.editControl as NumberBoxModel).reset($row.entity.AllocationSequence);
    (this.cells.pick_sequence.displayControl as TextModel).text = $row.entity.PickSequence?.toString();
    (this.cells.pick_sequence.editControl as NumberBoxModel).reset($row.entity.PickSequence);
    (this.cells.putaway_sequence.displayControl as TextModel).text = $row.entity.PutAwaySequence?.toString();
    (this.cells.putaway_sequence.editControl as NumberBoxModel).reset($row.entity.PutAwaySequence);
    (this.cells.mixing_restrictions.displayControl as TextModel).text = $row.entity?.MixingRule?.Name;
    (this.cells.mixing_restrictions.editControl as SelectBoxModel).reset($row.entity?.MixingRule?.Name);
    (this.cells.storage_category.displayControl as TextModel).text = $row.entity?.StorageCategory?.LookupCode;
    (this.cells.storage_category.editControl as SelectBoxModel).reset($row.entity?.StorageCategory?.LookupCode);

  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
      await this.on_save_new_row();
      this.isNew = false;
    } else {
      await this.on_save_existing_row();
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }

  //#region private flows
  on_init_new_row(event = null) {
    return this.on_init_new_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_init_new_rowInternal(
    $row: ExcelLocationImport_excel_location_import_gridComponentRowModel,
  $grid: ExcelLocationImport_excel_location_import_gridComponent, 
    $shell: ExcelLocationImport_ShellService,
    $datasources: ExcelLocationImport_DatasourceService,
    $flows: ExcelLocationImport_FlowService,
    $reports: ExcelLocationImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelLocationImport_OperationService,
    $utils: UtilsService,
    $context: ExcelLocationImport_excel_location_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelLocationImport_LocalizationService,
    $event: any
  ) {
  // Retrieve next LocationContainer.Id
  const nextId = (await $flows.Utilities.reserve_nextId_flow({entity: "LocationContainer"})).nextId;
  $row.entity = { Id: nextId };
  
  // Unlock fields
  $row.cells.warehouse.editControl.readOnly = false;
  $row.cells.type.editControl.readOnly = false;
  $row.cells.name.editControl.readOnly = false;
  $row.cells.is_loose.editControl.readOnly = false;
  $row.cells.is_primary.editControl.readOnly = false;
  $row.cells.mixing_restrictions.editControl.readOnly = false;
  $row.cells.storage_category.editControl.readOnly = false;
  $row.cells.status.editControl.readOnly = false;
  }
  on_save_new_row(event = null) {
    return this.on_save_new_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_new_rowInternal(
    $row: ExcelLocationImport_excel_location_import_gridComponentRowModel,
  $grid: ExcelLocationImport_excel_location_import_gridComponent, 
    $shell: ExcelLocationImport_ShellService,
    $datasources: ExcelLocationImport_DatasourceService,
    $flows: ExcelLocationImport_FlowService,
    $reports: ExcelLocationImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelLocationImport_OperationService,
    $utils: UtilsService,
    $context: ExcelLocationImport_excel_location_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelLocationImport_LocalizationService,
    $event: any
  ) {
  // Check required fields
  const allRequiredFieldsHaveValue = $utils.isAllDefined(
      $row.cells.warehouse.editControl.value,
      $row.cells.parent.editControl.value,
      $row.cells.name.editControl.value,
      $row.cells.type.editControl.value
  );
  
  var errors = '';
  
  if (allRequiredFieldsHaveValue === false) {
      $shell.ExcelLocationImport.openErrorDialog('Save', 'Missing required fields');
      throw new Error('Missing required fields'); // To prevent display mode
  }
  else {
      try {
  
          const location = (await $datasources.ExcelLocationImport.ds_get_locations_by_name_and_warehouseId.get({
              warehouseId: $row.cells.warehouse.editControl.value,
              name: $row.cells.name.editControl.value
          })).result;
          if ($utils.isDefined(location)) {
              errors += 'Duplicate location found';
              $row.cells.error.displayControl.text = errors;
              throw new Error('Duplicate location found');
          }
  
          let payload = {
              "Id": $row.entity.Id,
              "WarehouseId": $row.cells.warehouse.editControl.value,
              "ParentId": $row.cells.parent.editControl.value,
              "StatusId": $row.cells.status.editControl.value ?? 1,
              "Depth": 1,
              "Path": '/',
              "Name": $row.cells.name.editControl.value,
              "TypeId": $row.cells.type.editControl.value,
              "IsLoose": $row.cells.is_loose.editControl.value == 'Y' ? true : false,
              "EligibleForAllocation": $row.cells.eligible_for_allocation.editControl.value == 'Y' ? true : false,
              "Enabled": true,
              "AllowInventoryIfNotActive": true,
              "GlobalAllocationSequence": parseNumber($row.cells.allocation_sequence.editControl.value),
              "GlobalPickSequence": parseNumber($row.cells.pick_sequence.editControl.value),
              "GlobalPutawaySequence": parseNumber($row.cells.putaway_sequence.editControl.value),
              "AllocationSequence": parseNumber($row.cells.allocation_sequence.editControl.value),
              "PickSequence": parseNumber($row.cells.pick_sequence.editControl.value),
              "PutawaySequence": parseNumber($row.cells.putaway_sequence.editControl.value),
              "ChildFootprint": parseNumber($row.cells.child_footprint.editControl.value),
              "ChildStackHeight": parseNumber($row.cells.child_stack_height.editControl.value),
              "Length": parseNumber($row.cells.length.editControl.value),
              "Width": parseNumber($row.cells.width.editControl.value),
              "Height": parseNumber($row.cells.height.editControl.value),
              "DimensionUomId": $row.cells.dimensions_uom.editControl.value,
              "WeightCapacity": parseNumber($row.cells.weight_capacity.editControl.value),
              "WeightUomId": $row.cells.weight_uom.editControl.value,
              // "VolumeCapacity": null,
              // "VolumeUomId": null,
              "ManufacturingLineFlag": false,
              "RestrictToReplenishmentMaterials": false,
              "PurgeAddedInventory": false,
              "IsPrimaryPick": $row.cells.is_primary.editControl.value == 'Y' ? true : false,
              "SkipCycleCount": false,
              "EligibleForManufacturingFeedback": false,
              "IsManufacturingStagingLocation": false,
              "AllowMoveTaskCreation": false,
              "DisableNonPreferredLocationAlertCreation": false,
              "SkipValidationRules": $row.cells.skip_validation.editControl.value == 'Y' ? true : false,
              "BreakInventoryToBasePackaging": false,
              "ConfirmInventoryDeletion": false,
              "EligibleForScaleTicket": false,
              "SkipAfterPickingCountBack": false,
              "AutoSelectCountOnCountBack": false,
              "MobileForceUserCountBack": false,
              "IsPackageVerification": false,
              "IsDynamicPrimaryPick": false,
              "MixingRuleId": $row.cells.mixing_restrictions.editControl.value,
              "StorageCategoryId": $row.cells.storage_category.editControl.value,
              "IsUsedForReturns": false
          };
  
          //Add missing fields for versions
          const versionChecks = [
              {
                  version: 6213, properties: {
                      IsUsedForReturns: false
                  }
              },
              {
                  version: 6753, properties: {
                      IsPackageVerification: false,
                      IsDynamicPrimaryPick: false
                  }
              },
              {
                  version: 7178, properties: {
                      AllowOnlyCLPs: false
                  }
              }
          ];
          
          versionChecks.forEach(check => {
              if ($grid.vars.footprintVersion >= check.version) {
                  payload = { ...check.properties, ...payload };
              }
          });
  
          await $flows.Utilities.crud_create_flow({ entitySet: 'LocationContainers', entity: payload });
  
          if ($row.cells.is_loose.editControl.value == 'Y') {
              // Create loose license plate
              const nextLicensePlateId = (await $flows.Utilities.reserve_nextId_flow({ entity: "LicensePlate" })).nextId;
  
              const licensePlatePayload = {
                  "Id": nextLicensePlateId,
                  "WarehouseId": $row.cells.warehouse.editControl.value,
                  "LocationId": $row.entity.Id,
                  "TypeId": 3,
                  "StatusId": 1,
                  "LookupCode": $row.cells.name.editControl.value,
                  "Archived": false
              };
  
              await $flows.Utilities.crud_create_flow({ entitySet: 'LicensePlates', entity: licensePlatePayload });
          }
  
          $row.refresh();
          $row.cells.error.displayControl.text = '';
  
          // Lock fields
          $row.cells.warehouse.editControl.readOnly = true;
          $row.cells.type.editControl.readOnly = true;
          $row.cells.name.editControl.readOnly = true;
          $row.cells.parent.editControl.readOnly = true;
          $row.cells.is_loose.editControl.readOnly = true;
          $row.cells.is_primary.editControl.readOnly = true;
          $row.cells.mixing_restrictions.editControl.readOnly = true;
          $row.cells.storage_category.editControl.readOnly = true;
      }
      catch (error) {
          $shell.ExcelLocationImport.openErrorDialog('Save', 'Error on save');
          throw error; // To prevent display mode
      }
  }
  
  
  
  /**********************************************
   * FUNCTIONS
  ***********************************************/
  function parseNumber(value: any) {
      if (!$utils.isDefinedTrimmed(value) || isNaN(Number(value))) {
          return null;
      }
  
      return Number(value);
  }
  }
  on_save_existing_row(event = null) {
    return this.on_save_existing_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_existing_rowInternal(
    $row: ExcelLocationImport_excel_location_import_gridComponentRowModel,
  $grid: ExcelLocationImport_excel_location_import_gridComponent, 
    $shell: ExcelLocationImport_ShellService,
    $datasources: ExcelLocationImport_DatasourceService,
    $flows: ExcelLocationImport_FlowService,
    $reports: ExcelLocationImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelLocationImport_OperationService,
    $utils: UtilsService,
    $context: ExcelLocationImport_excel_location_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelLocationImport_LocalizationService,
    $event: any
  ) {
  // Construct payload with any values that have changed
  const payload : any = {};
  
  // General Properties
  if ($row.cells.name.editControl.isChanged) 
  {
      payload.Name = $row.cells.name.editControl.value;
  }
  if ($row.cells.status.editControl.isChanged) 
  {
      payload.StatusId = $row.cells.status.editControl.value;
  }
  if ($row.cells.eligible_for_allocation.editControl.isChanged) 
  {
      payload.EligibleForAllocation = $row.cells.eligible_for_allocation.editControl.value == 'N' ? false : true;
  }
  if ($row.cells.skip_validation.editControl.isChanged) 
  {
      payload.SkipValidationRules = $row.cells.skip_validation.editControl.value == 'N' ? false : true;
  }
  if ($row.cells.child_footprint.editControl.isChanged) 
  {
      payload.ChildFootprint = $row.cells.child_footprint.editControl.value;
  }
  if ($row.cells.child_stack_height.editControl.isChanged) 
  {
      payload.ChildStackHeight = $row.cells.child_stack_height.editControl.value;
  }
  // Dimensions
  if ($row.cells.length.editControl.isChanged) 
  {
      payload.Length = $row.cells.length.editControl.value;
  }
  if ($row.cells.width.editControl.isChanged) 
  {
      payload.Width = $row.cells.width.editControl.value;
  }
  if ($row.cells.height.editControl.isChanged) 
  {
      payload.Height = $row.cells.height.editControl.value;
  }
  if ($row.cells.dimensions_uom.editControl.isChanged) 
  {
      payload.DimensionUomId = $row.cells.dimensions_uom.editControl.value;
  }
  // Weight
  if ($row.cells.weight_capacity.editControl.isChanged) 
  {
      payload.WeightCapacity = $row.cells.weight_capacity.editControl.value;
  }
  if ($row.cells.weight_uom.editControl.isChanged) 
  {
      payload.WeightUomId = $row.cells.weight_uom.editControl.value;
  }
  // Sequences
  if ($row.cells.allocation_sequence.editControl.isChanged) 
  {
      payload.AllocationSequence = $row.cells.allocation_sequence.editControl.value;
  }
  if ($row.cells.pick_sequence.editControl.isChanged) 
  {
      payload.PickSequence = $row.cells.pick_sequence.editControl.value;
  }
  if ($row.cells.putaway_sequence.editControl.isChanged) 
  {
      payload.PutAwaySequence = $row.cells.putaway_sequence.editControl.value;
  }
  
  if (!$utils.isDefined(payload)) { return; }
  
  // Make API call
  try 
  {
      (await $flows.Utilities.crud_update_flow({
          entitySet: 'LocationContainers',
          id: $row.entity.Id,
          entity: payload
      }));
      
      await $row.refresh();
  
      // Lock fields
      $row.cells.warehouse.editControl.readOnly = true;
      $row.cells.type.editControl.readOnly = true;
      $row.cells.name.editControl.readOnly = true;
      $row.cells.parent.editControl.readOnly = true;
      $row.cells.is_loose.editControl.readOnly = true;
  }
  catch (error)
  {
      $shell.ExcelLocationImport.showErrorDetails('Save', 'Error on save.', error);
      throw error; // To prevent display mode
  }
  }
  on_warehouse_change(event = null) {
    return this.on_warehouse_changeInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_warehouse_changeInternal(
    $row: ExcelLocationImport_excel_location_import_gridComponentRowModel,
  $grid: ExcelLocationImport_excel_location_import_gridComponent, 
    $shell: ExcelLocationImport_ShellService,
    $datasources: ExcelLocationImport_DatasourceService,
    $flows: ExcelLocationImport_FlowService,
    $reports: ExcelLocationImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelLocationImport_OperationService,
    $utils: UtilsService,
    $context: ExcelLocationImport_excel_location_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelLocationImport_LocalizationService,
    $event: any
  ) {
  // Set the grid warehouseId variable when the warehouse is changed.
  $row.vars.warehouseId = $row.cells.warehouse.editControl.value;
  
  $row.cells.parent.editControl.readOnly = false;
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => ExcelLocationImport_location_type_dd_singleComponent),
    forwardRef(() => ExcelLocationImport_warehouses_dd_singleComponent),
    forwardRef(() => ExcelLocationImport_zones_dd_singleComponent),
    forwardRef(() => ExcelLocationImport_materialstatuses_dd_singleComponent),
    forwardRef(() => ExcelLocationImport_yn_dd_singleComponent),
    forwardRef(() => ExcelLocationImport_measurement_units_dd_singleComponent),
    forwardRef(() => ExcelLocationImport_mixing_rule_dd_singleComponent),
    forwardRef(() => ExcelLocationImport_storage_category_dd_singleComponent),
  ],
  selector: 'ExcelLocationImport-excel_location_import_grid',
  templateUrl: './ExcelLocationImport.excel_location_import_grid.component.html'
})
export class ExcelLocationImport_excel_location_import_gridComponent extends BaseComponent implements OnInit, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IExcelLocationImport_excel_location_import_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
canAdd: boolean = true; 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);




  //#region Variables
  vars: { warehouseId?: number, Locations?: { Warehouse?: string, Parent?: string, Name?: string, Type?: string, Status?: string, IsLoose_YN?: string, EligibleForAllocation_YN?: string, Length?: string, Width?: string, Height?: string, DimensionsUom?: string, Weight?: string, WeightUom?: string, ChildFootprint?: string, ChildStackHeight?: string, PickSequence?: string, AllocationSequence?: string, PutawaySequence?: string, IsPrimary_YN?: string, StorageCategory?: string, MixingRestrictions?: string, SkipValidation_YN?: string }[], BatchSize?: number, Retry?: number, footprintVersion?: number } = { };
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     Id: new GridHeaderModel(new HeaderStyles(null, null), 'Id', 'ID', false, false, null, false),       import_status: new GridHeaderModel(new HeaderStyles(null, null), 'import_status', 'Import status', false, false, null, false),       row_count: new GridHeaderModel(new HeaderStyles(null, null), 'row_count', 'Row count', false, false, null, false),       error: new GridHeaderModel(new HeaderStyles(null, null), 'error', 'Errors', false, false, null, false),       type: new GridHeaderModel(new HeaderStyles(null, null), 'type', 'Type', true, false, null, false),       warehouse: new GridHeaderModel(new HeaderStyles(null, null), 'warehouse', 'Warehouse', true, false, null, false),       parent: new GridHeaderModel(new HeaderStyles(null, null), 'parent', 'Parent', true, false, null, false),       name: new GridHeaderModel(new HeaderStyles(null, null), 'name', 'Name', true, false, null, false),       status: new GridHeaderModel(new HeaderStyles(null, null), 'status', 'Status', false, false, null, false),       eligible_for_allocation: new GridHeaderModel(new HeaderStyles(null, null), 'eligible_for_allocation', 'Eligible for allocation', false, false, null, false),       is_loose: new GridHeaderModel(new HeaderStyles(null, null), 'is_loose', 'Is loose', false, false, null, false),       is_primary: new GridHeaderModel(new HeaderStyles(null, null), 'is_primary', 'Is primary', false, false, null, false),       length: new GridHeaderModel(new HeaderStyles(null, null), 'length', 'Length', false, false, null, false),       width: new GridHeaderModel(new HeaderStyles(null, null), 'width', 'Width', false, false, null, false),       height: new GridHeaderModel(new HeaderStyles(null, null), 'height', 'Height', false, false, null, false),       dimensions_uom: new GridHeaderModel(new HeaderStyles(null, null), 'dimensions_uom', 'Dimensions UOM', false, false, null, false),       weight_capacity: new GridHeaderModel(new HeaderStyles(null, null), 'weight_capacity', 'Weight capacity', false, false, null, false),       weight_uom: new GridHeaderModel(new HeaderStyles(null, null), 'weight_uom', 'Weight UOM', false, false, null, false),       child_footprint: new GridHeaderModel(new HeaderStyles(null, null), 'child_footprint', 'Child footprint', false, false, null, false),       child_stack_height: new GridHeaderModel(new HeaderStyles(null, null), 'child_stack_height', 'Child stack height', false, false, null, false),       skip_validation: new GridHeaderModel(new HeaderStyles(null, null), 'skip_validation', 'Skip validation', false, false, null, false),       allocation_sequence: new GridHeaderModel(new HeaderStyles(null, null), 'allocation_sequence', 'Allocation sequence', false, false, null, false),       pick_sequence: new GridHeaderModel(new HeaderStyles(null, null), 'pick_sequence', 'Pick sequence', false, false, null, false),       putaway_sequence: new GridHeaderModel(new HeaderStyles(null, null), 'putaway_sequence', 'Putaway sequence', false, false, null, false),       mixing_restrictions: new GridHeaderModel(new HeaderStyles(null, null), 'mixing_restrictions', 'Mixing restrictions', false, false, null, false),       storage_category: new GridHeaderModel(new HeaderStyles(null, null), 'storage_category', 'Storage category', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: ExcelLocationImport_excel_location_import_gridComponentRowModel[] = [];


  topToolbar = {
      linecount: new ToolModel(new ButtonModel('linecount', new ButtonStyles(null, null), false, false, false, 'Line count', '', null)
    , false)
  };

  bottomToolbar = {
    addLine : new ToolModel(new ButtonModel(null, null, false, false, false, 'Add row', 'icon-ic_fluent_add_circle_20_regular')),
  };

  formGroup: FormGroup = new FormGroup({
    batch_size: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  filters = {
    batch_size: new FieldModel(new NumberBoxModel(this.formGroup.controls['batch_size'] as DatexFormControl, null, false, false, '', '', null)
, new ControlContainerStyles(null, null), 'Batch size', false, false),
  }

  //#region filters inParams
  //#endregion filters inParams


  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: ExcelLocationImport_ShellService,
    private $datasources: ExcelLocationImport_DatasourceService,
    private $flows: ExcelLocationImport_FlowService,
    private $reports: ExcelLocationImport_ReportService,
    private $localization: ExcelLocationImport_LocalizationService,
    private $operations: ExcelLocationImport_OperationService,
    private $logger: CleanupLoggerService,
    private $context: ExcelLocationImport_excel_location_import_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Location import';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 10;

    (this.filters.batch_size.control as NumberBoxModel).reset(50);

    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    if(!this.formGroup.valid) {
      return;
    }
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      warehouseId:  $grid.vars.warehouseId ,
    };
    try {
      const data = await this.$datasources.ExcelLocationImport.ds_location_import_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IExcelLocationImport_excel_location_import_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new ExcelLocationImport_excel_location_import_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }


  async addRow(entity?: IExcelLocationImport_excel_location_import_gridComponentEntity) {
    const row = new ExcelLocationImport_excel_location_import_gridComponentRowModel(
      this,
      this.$utils,
      this.$settings,
      this.$shell, 
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$localization,
      this.$operations,
      this.$logger,
      this.$context);
    await row.$initializeNew(entity);
    this.rows.push(row);
    row.setEditMode();
    return row;
  }
  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: ExcelLocationImport_excel_location_import_gridComponent,
  
    $shell: ExcelLocationImport_ShellService,
    $datasources: ExcelLocationImport_DatasourceService,
    $flows: ExcelLocationImport_FlowService,
    $reports: ExcelLocationImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelLocationImport_OperationService,
    $utils: UtilsService,
    $context: ExcelLocationImport_excel_location_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelLocationImport_LocalizationService,
    $event: any
  ) {
  // Initialize WarehouseId so no data is populated in grid
  $grid.vars.warehouseId = 0;
  
  // Initialize objects
  $grid.topToolbar.linecount.hidden = true;
  
  //Start Hidden
  $grid.headers.import_status.hidden = true;
  $grid.headers.row_count.hidden = true;
  
  $grid.vars.BatchSize = 50;
  $grid.vars.Retry = 3;
  
  
  $grid.vars.footprintVersion = await getLastVersionPart();
  
  async function getLastVersionPart(): Promise<number> {
      const footprintVersion = (await $flows.Utilities.check_footprint_version(null));
      const parts = footprintVersion.productVersion.split('.');
      return Number(parts[parts.length - 1]);
  }
  
  }
  on_excel_export(event = null) {
    return this.on_excel_exportInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_excel_exportInternal(
    $grid: ExcelLocationImport_excel_location_import_gridComponent,
  
    $shell: ExcelLocationImport_ShellService,
    $datasources: ExcelLocationImport_DatasourceService,
    $flows: ExcelLocationImport_FlowService,
    $reports: ExcelLocationImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelLocationImport_OperationService,
    $utils: UtilsService,
    $context: ExcelLocationImport_excel_location_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelLocationImport_LocalizationService,
    $event: any
  ) {
  const wb = $event;
  
  const locations = [];
  
  locations.push({
  	Warehouse : 'Warehouse Name',
  	Parent : 'Name of parent zone',
  	Name : 'Name of location',
      Type : 'Zone, Location',
  	Status : 'Active, Damaged, Discontinued, Inactive',
  	IsLoose_YN : 'N',
      IsPrimary_YN : 'N',
  	EligibleForAllocation_YN : 'Y',
  	Length : '',
  	Width : '',
  	Height : '',
  	DimensionsUom : 'cm, ft, in, m',
  	Weight : '',
  	WeightUom : 'g, kg, lb, mt, oz, T, t oz',
  	ChildFootprint : '',
  	ChildStackHeight : '',
      SkipValidation_YN : 'N',
  	PickSequence : '',
  	AllocationSequence : '',
  	PutawaySequence : '',
      MixingRestrictions : 'Owners, Projects, Materials, Vendor Lots, Lots',
      StorageCategory : ''
  });
  
  const ws = $utils.excel.json_to_sheet(locations);
  
  $utils.excel.book_append_sheet(wb, ws, 'LocationsImport');
  }
  on_excel_import_individual(event = null) {
    return this.on_excel_import_individualInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_excel_import_individualInternal(
    $grid: ExcelLocationImport_excel_location_import_gridComponent,
  
    $shell: ExcelLocationImport_ShellService,
    $datasources: ExcelLocationImport_DatasourceService,
    $flows: ExcelLocationImport_FlowService,
    $reports: ExcelLocationImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelLocationImport_OperationService,
    $utils: UtilsService,
    $context: ExcelLocationImport_excel_location_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelLocationImport_LocalizationService,
    $event: any
  ) {
  const startTime = new Date();
  
  const _batchSize = 500;
  
  const Locations = $grid.vars.Locations;
  $grid.topToolbar.linecount.control.label = 'Preparing Data...';
  
  // Initialize grid and data
  const candidates = [];
  var linecount = 0;
  var confirmLineCount = 0;
  var totalLineCount = Locations.length;
  
  // Get Bulk Data
  var warehouses = (await getWarehousesPool());
  var types = (await getTypesPool());
  var statuses = (await getStatusPool());
  var measurementUnit = (await getMeasurementUnitsPool());
  var mixingRestrictions = (await getMixingRestrictionsPool());
  var storageCategories = (await getStorageCategoriesPool());
  
  for (const Location of Locations) {
  
      linecount = linecount + 1;
      $grid.topToolbar.linecount.control.label = 'Validating Line ' + linecount.toString() + ' of ' + totalLineCount.toString();
  
      var errors = '';
      if ($utils.isDefined(Location.Name)) {
          var locationName = Location.Name.toString();
      }
      if ($utils.isDefined(Location.Warehouse)) {
          var warehouseName = Location.Warehouse.toString();
      }
      if ($utils.isDefined(Location.Parent)) {
          var parentName = Location.Parent.toString();
      }
  
      const nextId = (await $flows.Utilities.reserve_nextId_flow({ entity: "LocationContainer" })).nextId;
      const row = await $grid.addRow({
          Id: nextId
      });
  
      var warehouseId = null;
      if ($utils.isDefined(Location.Warehouse)) {
          const warehouseFound = warehouses.find(
              w => w.Name.trim().toLowerCase() === Location.Warehouse.trim().toLowerCase()
          );
          if ($utils.isDefined(warehouseFound)) {
              warehouseId = warehouseFound.Id;
              row.cells.warehouse.editControl.value = warehouseId;
              row.vars.warehouseId = warehouseId;
          }
          else {
              row.cells.warehouse.editControl.value = null;
              errors += 'Warehouse does not exist' + ' : ';
              row.cells.warehouse.editControl.readOnly = false;
          }
      } else {
          errors += 'Warehouse not provided' + ' : '
          row.cells.warehouse.editControl.readOnly = false;
      }
  
      var typeId = null;
      if ($utils.isDefined(Location.Type)) {
          const typeFound = types.find(
              t => t.Name === Location.Type.toString()
          );
          if ($utils.isDefined(typeFound)) {
              typeId = typeFound.Id;
              row.cells.type.editControl.value = typeId;
          }
          else {
              row.cells.type.editControl.value = null;
              errors += 'Location type does not exist' + ' : ';
              row.cells.type.editControl.readOnly = false;
          }
      } else {
          errors += 'Location type not provided' + ' : '
          row.cells.type.editControl.readOnly = false;
      }
  
      var statusId = null;
      if ($utils.isDefined(Location.Status)) {
          const statusFound = statuses.find(
              s => s.Name === Location.Status.toString()
          );
          if ($utils.isDefined(statusFound)) {
              statusId = statusFound.Id;
              row.cells.status.editControl.value = statusId;
          }
          else {
              row.cells.status.editControl.value = null;
              errors += 'Status does not exist' + ' : ';
              row.cells.status.editControl.readOnly = false;
          }
      } else {
          errors += 'Status not provided' + ' : '
          row.cells.status.editControl.readOnly = false;
      }
  
      var mixingRuleId = null;
      if ($utils.isDefined(Location.MixingRestrictions)) {
          const mixingRuleFound = mixingRestrictions.find(
              m => m.Name === Location.MixingRestrictions.toString()
          );
          if ($utils.isDefined(mixingRuleFound)) {
              mixingRuleId = mixingRuleFound.Id;
              row.cells.mixing_restrictions.editControl.value = mixingRuleId;
          }
          else {
              row.cells.mixing_restrictions.editControl.value = null;
              errors += 'Location mixing restriction does not exist' + ' : ';
              row.cells.mixing_restrictions.editControl.readOnly = false;
          }
      } else {
          row.cells.mixing_restrictions.editControl.readOnly = false;
      }
  
      var storageRuleId = null;
      if ($utils.isDefined(Location.StorageCategory)) {
          const storageRuleFound = storageCategories.find(
              s => s.LookupCode === Location.StorageCategory.toString()
          );
          const storageRuleFound2 = storageCategories.find(
              s => s.LookupCode == Location.StorageCategory.toString()
          );
          $utils.isDefined(storageRuleFound2)
          if ($utils.isDefined(storageRuleFound)) {
              storageRuleId = storageRuleFound.Id;
              row.cells.storage_category.editControl.value = storageRuleId;
          }
          else {
              row.cells.storage_category.editControl.value = null;
              errors += 'Location storage rule does not exist' + ' : ';
              row.cells.storage_category.editControl.readOnly = false;
          }
      } else {
          row.cells.storage_category.editControl.readOnly = false;
      }
  
  
      // To do check if the weight capacity or L W H is provided then the corresponding Uom should be required...error
      var weightUomId = null;
      if ($utils.isDefined(Location.WeightUom)) {
          const weightUomFound = measurementUnit.find(
              u => u.Short_name === Location.WeightUom.toString()
          );
          if ($utils.isDefined(weightUomFound)) {
              weightUomId = weightUomFound.Id;
              row.cells.weight_uom.editControl.value = weightUomId;
          }
          else {
              errors += 'Weight Uom does not exist'
              row.cells.weight_uom.editControl.readOnly = false;
          }
      } else {
          row.cells.weight_uom.editControl.readOnly = false;
      }
  
      var dimensionUomId = null;
      if ($utils.isDefined(Location.DimensionsUom)) {
          const dimensionUomFound = measurementUnit.find(
              u => u.Short_name === Location.DimensionsUom.toString()
          );
          if ($utils.isDefined(dimensionUomFound)) {
              dimensionUomId = dimensionUomFound.Id;
              row.cells.dimensions_uom.editControl.value = dimensionUomId;
          }
          else {
              errors += 'Dimension Uom does not exist'
              row.cells.dimensions_uom.editControl.readOnly = false;
          }
      } else {
          row.cells.dimensions_uom.editControl.readOnly = false;
      }
  
      if (Location.IsLoose_YN === 'Y') {
          row.cells.is_loose.editControl.value = 'Y';
      } else {
          row.cells.is_loose.editControl.value = 'N';
      }
      if (Location.IsPrimary_YN === 'Y') {
          row.cells.is_primary.editControl.value = 'Y';
      } else {
          row.cells.is_primary.editControl.value = 'N';
      }
  
      if (Location.EligibleForAllocation_YN === 'Y') {
          row.cells.eligible_for_allocation.editControl.value = 'Y';
      } else {
          row.cells.eligible_for_allocation.editControl.value = 'N';
      }
  
      if (Location.SkipValidation_YN === 'Y') {
          row.cells.skip_validation.editControl.value = 'Y';
      } else {
          row.cells.skip_validation.editControl.value = 'N';
      }
  
      if ($utils.isDefined(Location.Length)) { row.cells.length.editControl.value = Location.Length; }
      if ($utils.isDefined(Location.Width)) { row.cells.width.editControl.value = Location.Width; }
      if ($utils.isDefined(Location.Height)) { row.cells.height.editControl.value = Location.Height; }
      if ($utils.isDefined(Location.Weight)) { row.cells.weight_capacity.editControl.value = Location.Weight; }
      if ($utils.isDefined(Location.ChildFootprint)) { row.cells.child_footprint.editControl.value = Location.ChildFootprint; }
      if ($utils.isDefined(Location.ChildStackHeight)) { row.cells.child_stack_height.editControl.value = Location.ChildStackHeight; }
      if ($utils.isDefined(Location.PickSequence)) { row.cells.pick_sequence.editControl.value = Location.PickSequence; }
      if ($utils.isDefined(Location.AllocationSequence)) { row.cells.allocation_sequence.editControl.value = Location.AllocationSequence; }
      if ($utils.isDefined(Location.PutawaySequence)) { row.cells.putaway_sequence.editControl.value = Location.PutawaySequence; }
  
  
      if ($utils.isDefined(locationName)) {
          row.cells.name.editControl.value = locationName;
      } else {
          errors += 'Location Name not provided ' + ' : ';
  
      }
  
      if ($utils.isDefined(parentName)) {
          const parentCheck = (await $datasources.ExcelLocationImport.ds_get_locations_by_name_and_warehouseId.get({
              name: parentName,
              warehouseId: warehouseId
          })).result
          if ($utils.isDefined(parentCheck)) {
              row.cells.parent.editControl.value = parentCheck.Id;
          }
          else {
              row.cells.parent.displayControl.text = parentName;
          }
      }
      else {
          errors += 'Parent location not provided ' + ' : ';
      }
  
      if ($utils.isDefined(warehouseId)) {
          const locationNameCheck = (await $datasources.ExcelLocationImport.ds_get_locations_by_name_and_warehouseId.get({
              warehouseId: warehouseId,
              name: locationName
          })).result
  
          if ($utils.isDefined(locationNameCheck)) {
              errors += 'Location Name already exists ' + ' : ';
          }
      }
  
      row.cells.error.displayControl.text = errors;
      candidates.push({ row: row, errors: errors });
  
  
  }
  
  
  var totalConfirmLineCount = candidates.length;
  
  // Sort Candidates in descending order by the Type
  candidates.sort((a, b) => (a.row.cells.type.editControl.value > b.row.cells.type.editControl.value) ? 1 : ((b.row.cells.type.editControl.value > a.row.cells.type.editControl.value) ? -1 : 0));
  candidates.reverse();
  
  var passIndex = 1;
  const maxPassThreshold = 10;
  var skipImport = false;
  
  var index = candidates.length - 1;
  while (index >= 0 && passIndex <= maxPassThreshold) {
      skipImport = false;
      const noErrors = candidates[index].errors === '';
      errors = "";
  
      candidates[index].row.cells.warehouse.editControl.readOnly = false;
      candidates[index].row.cells.type.editControl.readOnly = false;
      candidates[index].row.cells.parent.editControl.readOnly = false;
      candidates[index].row.cells.is_loose.editControl.readOnly = false;
      candidates[index].row.cells.name.editControl.readOnly = false;
      candidates[index].row.cells.is_primary.editControl.readOnly = false;
      //candidates[index].row.cells.mixing_restrictions.editControl.readOnly = false;
      //candidates[index].row.cells.storage_category.editControl.readOnly = false;
  
      if (noErrors) {
  
          //Check for duplicates within the same file
          const locationCheck = (await $datasources.ExcelLocationImport.ds_get_locations_by_name_and_warehouseId.get({
              name: candidates[index].row.cells.name.editControl.value,
              warehouseId: candidates[index].row.cells.warehouse.editControl.value
          })).result
  
          //Check that parent location exists in FootPrint
          if (!$utils.isDefined(candidates[index].row.cells.parent.editControl.value)) {
              var parentCheck = (await $datasources.ExcelLocationImport.ds_get_locations_by_name_and_warehouseId.get({
                  name: candidates[index].row.cells.parent.displayControl.text,
                  warehouseId: candidates[index].row.cells.warehouse.editControl.value
              })).result
  
              if (!$utils.isDefined(parentCheck)) {
                  if (passIndex >= maxPassThreshold) {
                      errors += 'Parent location does not exist' + ' : ';
                  }
                  skipImport = true;
              }
              else {
                  candidates[index].row.cells.parent.editControl.value = parentCheck.Id;
              }
          }
  
          // Validations
          if ($utils.isDefined(locationCheck)) {
              errors += 'Duplicate Location ' + ' : ';
          }
  
  
          if (errors != '') {
              candidates[index].row.cells.error.displayControl.text = errors;
              candidates.splice(index, 1); // Remove from collection
          }
          else if (!skipImport) {
  
              try {
                  confirmLineCount = confirmLineCount + 1;
                  $grid.topToolbar.linecount.control.label = 'Creating Location ' + confirmLineCount.toString() + ' of ' + totalConfirmLineCount.toString();
  
  
                  // Construct payload to create new location
                  let payload = {
                      "Id": candidates[index].row.entity.Id,
                      "WarehouseId": candidates[index].row.cells.warehouse.editControl.value,
                      "ParentId": candidates[index].row.cells.parent.editControl.value,
                      "StatusId": candidates[index].row.cells.status.editControl.value,
                      "Depth": 1,
                      "Path": '/',
                      "Name": candidates[index].row.cells.name.editControl.value,
                      "TypeId": candidates[index].row.cells.type.editControl.value,
                      "IsLoose": candidates[index].row.cells.is_loose.editControl.value === 'Y' ? true : false,
                      "EligibleForAllocation": candidates[index].row.cells.eligible_for_allocation.editControl.value === 'Y' ? true : false,
                      "Enabled": true,
                      "AllowInventoryIfNotActive": true,
                      "GlobalAllocationSequence": parseNumber(candidates[index].row.cells.allocation_sequence.editControl.value),
                      "GlobalPickSequence": parseNumber(candidates[index].row.cells.pick_sequence.editControl.value),
                      "GlobalPutawaySequence": parseNumber(candidates[index].row.cells.putaway_sequence.editControl.value),
                      "AllocationSequence": parseNumber(candidates[index].row.cells.allocation_sequence.editControl.value),
                      "PickSequence": parseNumber(candidates[index].row.cells.pick_sequence.editControl.value),
                      "PutawaySequence": parseNumber(candidates[index].row.cells.putaway_sequence.editControl.value),
                      "ChildFootprint": parseNumber(candidates[index].row.cells.child_footprint.editControl.value),
                      "ChildStackHeight": parseNumber(candidates[index].row.cells.child_stack_height.editControl.value),
                      "Length": parseNumber(candidates[index].row.cells.length.editControl.value),
                      "Width": parseNumber(candidates[index].row.cells.width.editControl.value),
                      "Height": parseNumber(candidates[index].row.cells.height.editControl.value),
                      "DimensionUomId": candidates[index].row.cells.dimensions_uom.editControl.value,
                      "WeightCapacity": parseNumber(candidates[index].row.cells.weight_capacity.editControl.value),
                      "WeightUomId": candidates[index].row.cells.weight_uom.editControl.value,
                      // "VolumeCapacity": null,
                      // "VolumeUomId": null,
                      "ManufacturingLineFlag": false,
                      "RestrictToReplenishmentMaterials": false,
                      "PurgeAddedInventory": false,
                      "IsPrimaryPick": candidates[index].row.cells.is_primary.editControl.value === 'Y' ? true : false,
                      "SkipCycleCount": false,
                      "EligibleForManufacturingFeedback": false,
                      "IsManufacturingStagingLocation": false,
                      "AllowMoveTaskCreation": false,
                      "DisableNonPreferredLocationAlertCreation": false,
                      "SkipValidationRules": candidates[index].row.cells.skip_validation.editControl.value === 'Y' ? true : false,
                      "BreakInventoryToBasePackaging": false,
                      "ConfirmInventoryDeletion": false,
                      "EligibleForScaleTicket": false,
                      "SkipAfterPickingCountBack": false,
                      "AutoSelectCountOnCountBack": false,
                      "MobileForceUserCountBack": false,
                      "IsPackageVerification": false,
                      "IsDynamicPrimaryPick": false,
                      "MixingRuleId": candidates[index].row.cells.mixing_restrictions.editControl.value,
                      "StorageCategoryId": candidates[index].row.cells.storage_category.editControl.value,
                      "IsUsedForReturns": false
                  };
  
                  //Add missing fields for versions
                  const versionChecks = [
                      {
                          version: 6213, properties: {
                              IsUsedForReturns: false
                          }
                      },
                      {
                          version: 6753, properties: {
                              IsPackageVerification: false,
                              IsDynamicPrimaryPick: false
                          }
                      },
                      {
                          version: 7178, properties: {
                              AllowOnlyCLPs: false
                          }
                      }
                  ];
  
                  versionChecks.forEach(check => {
                      if ($grid.vars.footprintVersion >= check.version) {
                          payload = { ...check.properties, ...payload };
                      }
                  });
  
  
                  await $flows.Utilities.crud_create_flow({ entitySet: 'LocationContainers', entity: payload });
  
                  // Create loose license plate if location is loose
                  if (candidates[index].row.cells.is_loose.editControl.value == 'Y') {
                      const nextLicensePlateId = (await $flows.Utilities.reserve_nextId_flow({ entity: "LicensePlate" })).nextId;
  
                      const licensePlatePayload = {
                          "Id": nextLicensePlateId,
                          "WarehouseId": candidates[index].row.cells.warehouse.editControl.value,
                          "LocationId": candidates[index].row.entity.Id,
                          "TypeId": 3,
                          "StatusId": 1,
                          "LookupCode": candidates[index].row.cells.name.editControl.value,
                          "Archived": false
                      };
  
                      await $flows.Utilities.crud_create_flow({ entitySet: 'LicensePlates', entity: licensePlatePayload });
                  }
  
                  // Refresh Grid row
                  candidates[index].row.refresh();
                  candidates[index].row.setDisplayMode();
                  candidates[index].row.isNew = false;
  
                  candidates[index].row.cells.error.displayControl.text = '';
                  candidates[index].row.cells.warehouse.editControl.readOnly = true;
                  candidates[index].row.cells.type.editControl.readOnly = true;
                  candidates[index].row.cells.parent.editControl.readOnly = true;
                  candidates[index].row.cells.is_loose.editControl.readOnly = true;
                  candidates[index].row.cells.name.editControl.readOnly = true;
                  candidates[index].row.cells.is_primary.editControl.readOnly = true;
                  candidates[index].row.cells.mixing_restrictions.editControl.readOnly = true;
                  candidates[index].row.cells.storage_category.editControl.readOnly = true;
  
                  // Remove from collection
                  candidates.splice(index, 1);
              }
  
              catch (error) {
                  errors += 'Error calling calling crud Api'
                  candidates[index].row.cells.error.displayControl.text = errors;
                  // Remove from collection
                  candidates.splice(index, 1);
  
                  $grid.topToolbar.linecount.hidden = true;
                  throw error; // to prevent displayMode 
              }
          }
      }
      else {
          //Remove from collection
          candidates.splice(index, 1);
      }
  
  
      index--;
      if (index < 0 && candidates.length > 0) {
          index = candidates.length - 1;
          passIndex++;
      }
  }
  
  $grid.topToolbar.linecount.hidden = true;
  
  console.log("Import completed successfully after " + passIndex.toString() + " passes in " + (((new Date()).getTime() - startTime.getTime()) / 1000));
  
  
  /**********************************************************
   * FUNCTIONS
  **********************************************************/
  async function getWarehousesPool() {
      let warehouseNames: string[] = Array.from(new Set(Locations.filter(ol => $utils.isDefinedTrimmed(ol.Warehouse?.toString())).map(ol => ol.Warehouse?.toString())));
      let index = 0;
  
      while (index < warehouseNames.length) {
          var results = (results || []).concat((await $datasources.ExcelLocationImport.ds_get_warehouses_by_names.get({ warehouseNames: warehouseNames.slice(index, index + _batchSize) })).result);
          index += _batchSize;
      }
  
      return results
  }
  
  async function getTypesPool() {
      let locationTypes: string[] = Array.from(new Set(Locations.filter(ol => $utils.isDefinedTrimmed(ol.Type?.toString())).map(ol => ol.Type?.toString())));
      let index = 0;
  
      while (index < locationTypes.length) {
          var results = (results || []).concat((await $datasources.ExcelLocationImport.ds_get_locationtypes_by_names.get({ locationTypes: locationTypes.slice(index, index + _batchSize) })).result);
          index += _batchSize;
      }
  
      return results
  }
  
  async function getStatusPool() {
      let statusNames: string[] = Array.from(new Set(Locations.filter(ol => $utils.isDefinedTrimmed(ol.Status?.toString())).map(ol => ol.Status?.toString())));
      let index = 0;
  
      while (index < statusNames.length) {
          var results = (results || []).concat((await $datasources.ExcelLocationImport.ds_get_locationstatuses_by_names.get({ locationStatuses: statusNames.slice(index, index + _batchSize) })).result);
          index += _batchSize;
      }
  
      return results
  }
  async function getMeasurementUnitsPool() {
      let dimensionUoms: string[] = Array.from(new Set(Locations.filter(ol => $utils.isDefinedTrimmed(ol.DimensionsUom?.toString())).map(ol => ol.DimensionsUom?.toString())));
      let weightUoms: string[] = Array.from(new Set(Locations.filter(ol => $utils.isDefinedTrimmed(ol.WeightUom?.toString())).map(ol => ol.WeightUom?.toString())));
      var units = dimensionUoms.concat(weightUoms);
  
      let index = 0;
  
      while (index < units.length) {
          var results = (results || []).concat((await $datasources.ExcelLocationImport.ds_get_measurementunits_by_shortnames.get({ measurementUnitShortNames: units.slice(index, index + _batchSize) })).result);
          index += _batchSize;
      }
  
      return results
  }
  
  async function getMixingRestrictionsPool() {
      let mixingrules: string[] = Array.from(new Set(Locations.filter(ol => $utils.isDefinedTrimmed(ol.MixingRestrictions?.toString())).map(ol => ol.MixingRestrictions?.toString())));
      let index = 0;
  
      while (index < mixingrules.length) {
          var results = (results || []).concat((await $datasources.ExcelLocationImport.ds_get_mixingrestrictions_by_names.get({ mixingRestrictions: mixingrules.slice(index, index + _batchSize) })).result);
          index += _batchSize;
      }
  
      return results
  }
  async function getStorageCategoriesPool() {
      let storagerules: string[] = Array.from(new Set(Locations.filter(ol => $utils.isDefinedTrimmed(ol.StorageCategory?.toString())).map(ol => ol.StorageCategory?.toString())));
      let index = 0;
  
      while (index < storagerules.length) {
          var results = (results || []).concat((await $datasources.ExcelLocationImport.ds_get_storagecategories_by_lookupcode.get({ storageCategories: storagerules.slice(index, index + _batchSize) })).result);
          index += _batchSize;
      }
  
      return results
  }
  
  function parseNumber(value: any) {
      if (!$utils.isDefinedTrimmed(value) || isNaN(Number(value))) {
          return null;
      }
  
      return Number(value);
  }
  
  }
  on_excel_import_batch(event = null) {
    return this.on_excel_import_batchInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_excel_import_batchInternal(
    $grid: ExcelLocationImport_excel_location_import_gridComponent,
  
    $shell: ExcelLocationImport_ShellService,
    $datasources: ExcelLocationImport_DatasourceService,
    $flows: ExcelLocationImport_FlowService,
    $reports: ExcelLocationImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelLocationImport_OperationService,
    $utils: UtilsService,
    $context: ExcelLocationImport_excel_location_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelLocationImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 09/19/2024
  
  const batch_size = $grid.filters.batch_size.control.value ?? $grid.vars.BatchSize;
  const startTime = new Date();
  
  let Locations = $grid.vars.Locations;
  
  $grid.topToolbar.linecount.control.label = 'Preparing Batch Data...';
  
  $grid.headers.Id.hidden = true;
  $grid.headers.allocation_sequence.hidden = true;
  $grid.headers.child_footprint.hidden = true;
  $grid.headers.child_stack_height.hidden = true;
  $grid.headers.dimensions_uom.hidden = true;
  $grid.headers.eligible_for_allocation.hidden = true;
  $grid.headers.height.hidden = true;
  $grid.headers.is_loose.hidden = true;
  $grid.headers.length.hidden = true;
  $grid.headers.name.hidden = true;
  $grid.headers.parent.hidden = true;
  $grid.headers.pick_sequence.hidden = true;
  $grid.headers.putaway_sequence.hidden = true;
  $grid.headers.type.hidden = true;
  $grid.headers.warehouse.hidden = true;
  $grid.headers.weight_capacity.hidden = true;
  $grid.headers.weight_uom.hidden = true;
  $grid.headers.width.hidden = true;
  $grid.headers.status.hidden = true;
  $grid.headers.is_primary.hidden = true;
  $grid.headers.storage_category.hidden = true;
  $grid.headers.mixing_restrictions.hidden = true;
  $grid.headers.skip_validation.hidden = true;
  
  $grid.headers.import_status.hidden = false;
  $grid.headers.row_count.hidden = false;
  
  // Initialize grid and data
  const candidates = [];
  var linecount = 0;
  var confirmLineCount = 0;
  var totalLineCount = Locations.length;
  var row_number = 0;
  let row: any;
  let errors: string = '';
  
  //Set the first two rows
  row = await $grid.addRow({ Id: 1 });
  row.cells.import_status.displayControl.text = "Ready";
  row.cells.row_count.displayControl.text = totalLineCount.toLocaleString();
  
  $grid.topToolbar.linecount.control.label = 'Validating Batch Data...';
  
  $grid.topToolbar.linecount.control.label = 'Fixing names...';
  
  //Necesary in case there are location names that look like numbers
  for (let Location of Locations) {
      Location.Warehouse = validate_string_value(Location.Warehouse);
      Location.Parent = validate_string_value(Location.Parent);
      Location.Name = validate_string_value(Location.Name);
  }
  
  $grid.topToolbar.linecount.control.label = 'Warehouse validation...';
  
  //Validate Warehouse
  let warehouses = ((await $datasources.ExcelLocationImport.ds_warehouses_dd.get({})).result)?.map(w => w.Name);
  let locations_invalid_warehouse = Locations.filter(l => warehouses.indexOf(l.Warehouse) === -1)?.map(l => l.Warehouse); //Warehouse is NOT valid
  
  if ($utils.isDefined(locations_invalid_warehouse)) {
      if (locations_invalid_warehouse.length > 0) {
  
          Locations = Locations.filter(l => warehouses.indexOf(l.Warehouse) > -1); //Replace locations with only valid records
  
          let invalid_warehouses = locations_invalid_warehouse.filter((value, index, array) => array.indexOf(value) === index);
  
          row_number = $grid.rows.length;
  
          for (let invalid_warehouse of invalid_warehouses) {
  
              let invalid_warehouse_locations = locations_invalid_warehouse.filter(l => l === invalid_warehouse);
  
              if (invalid_warehouse === '') { invalid_warehouse = '<blank>' }
  
              row_number += 1;
              row = await $grid.addRow({ Id: row_number });
              row.cells.import_status.displayControl.text = 'Error';
              row.cells.error.displayControl.text = `Warehouse [${invalid_warehouse}] does not exist.`;
              row.cells.row_count.displayControl.text = invalid_warehouse_locations.length.toLocaleString();
          }
      }
  }
  
  $grid.topToolbar.linecount.control.label = 'Location type validation...';
  
  //Validate Location Types
  let types = ((await $datasources.ExcelLocationImport.ds_get_locationtypes_by_names.get({})).result)?.map(t => t.Name);
  let locations_invalid_type = Locations.filter(l => types.indexOf(l.Type) === -1)?.map(l => l.Type); //Type is NOT valid
  
  if ($utils.isDefined(locations_invalid_type)) {
      if (locations_invalid_type.length > 0) {
  
          Locations = Locations.filter(l => types.indexOf(l.Type) > -1); //Replace locations with only valid records
  
          let invalid_types = locations_invalid_type.filter((value, index, array) => array.indexOf(value) === index);
  
          row_number = $grid.rows.length;
  
          for (let invalid_type of invalid_types) {
  
              let invalid_location_types = locations_invalid_type.filter(l => l === invalid_type);
  
              if (invalid_type === '') { invalid_type = '<blank>' }
  
              row_number += 1;
              row = await $grid.addRow({ Id: row_number });
              row.cells.import_status.displayControl.text = 'Error';
              row.cells.error.displayControl.text = `Location type [${invalid_type}] is not valid.`;
              row.cells.row_count.displayControl.text = invalid_location_types.length.toLocaleString();
          }
      }
  }
  types = null;
  
  $grid.topToolbar.linecount.control.label = 'Location status validation...';
  
  //Validate Statuses
  let statuses = ((await $datasources.ExcelLocationImport.ds_get_locationstatuses_by_names.get({})).result)?.map(t => t.Name);
  let locations_invalid_status = Locations.filter(l => statuses.indexOf(l.Status) === -1)?.map(l => l.Status); //Status is NOT valid
  
  if ($utils.isDefined(locations_invalid_status)) {
      if (locations_invalid_status.length > 0) {
  
          Locations = Locations.filter(l => statuses.indexOf(l.Status) > -1); //Replace locations with only valid records
  
          let invalid_statuses = locations_invalid_status.filter((value, index, array) => array.indexOf(value) === index);
  
          row_number = $grid.rows.length;
  
          for (let invalid_status of invalid_statuses) {
  
              let invalid_location_statuses = locations_invalid_status.filter(l => l === invalid_status);
  
              if (invalid_status === '') { invalid_status = '<blank>' }
  
              row_number += 1;
              row = await $grid.addRow({ Id: row_number });
              row.cells.import_status.displayControl.text = 'Error';
              row.cells.error.displayControl.text = `Location status [${invalid_status}] is not valid.`;
              row.cells.row_count.displayControl.text = invalid_location_statuses.length.toLocaleString();
          }
      }
  }
  
  $grid.topToolbar.linecount.control.label = 'Dimensions validation...';
  
  //Validate Measurement Units
  let measurement_units = ((await $datasources.ExcelLocationImport.ds_measurement_units_dd.get({})).result)?.map(t => t.Short_name);
  let locations_invalid_dimension = Locations.filter(l => measurement_units.indexOf(l.DimensionsUom) === -1)?.map(l => l.DimensionsUom); //Dimension is NOT valid
  
  if ($utils.isDefined(locations_invalid_dimension)) {
      if (locations_invalid_dimension.length > 0) {
  
          Locations = Locations.filter(l => measurement_units.indexOf(l.DimensionsUom) > -1); //Replace locations with only valid records
  
          let invalid_dimensions = locations_invalid_dimension.filter((value, index, array) => array.indexOf(value) === index);
  
          row_number = $grid.rows.length;
  
          for (let invalid_dimension of invalid_dimensions) {
  
              let invalid_location_dims = locations_invalid_dimension.filter(l => l === invalid_dimension);
  
              if (invalid_dimension === '') { invalid_dimension = '<blank>' }
  
              row_number += 1;
              row = await $grid.addRow({ Id: row_number });
              row.cells.import_status.displayControl.text = 'Error';
              row.cells.error.displayControl.text = `Dimension [${invalid_dimension}] is not valid.`;
              row.cells.row_count.displayControl.text = invalid_location_dims.length.toLocaleString();
          }
      }
  }
  
  $grid.topToolbar.linecount.control.label = 'Weight uom validation...';
  
  let locations_invalid_weight = Locations.filter(l => measurement_units.indexOf(l.WeightUom) === -1)?.map(l => l.WeightUom); //Weight is NOT valid
  
  if ($utils.isDefined(locations_invalid_weight)) {
      if (locations_invalid_weight.length > 0) {
  
          Locations = Locations.filter(l => measurement_units.indexOf(l.WeightUom) > -1); //Replace locations with only valid records
  
          let invalid_weights = locations_invalid_weight.filter((value, index, array) => array.indexOf(value) === index);
  
          row_number = $grid.rows.length;
  
          for (let invalid_weight of invalid_weights) {
  
              let invalid_location_weights = locations_invalid_weight.filter(l => l === invalid_weight);
  
              if (invalid_weight === '') { invalid_weight = '<blank>' }
  
              row_number += 1;
              row = await $grid.addRow({ Id: row_number });
              row.cells.import_status.displayControl.text = 'Error';
              row.cells.error.displayControl.text = `Weight UOM [${invalid_weight}] is not valid.`;
              row.cells.row_count.displayControl.text = invalid_location_weights.length.toLocaleString();
          }
      }
  }
  
  $grid.topToolbar.linecount.control.label = 'Numeric validation...';
  
  //Validate Numbers
  let locations_invalid_numbers = Locations.filter(l => $utils.isDefined(l.AllocationSequence) && isNaN(Number(l.AllocationSequence)))?.map(l => l.AllocationSequence); //A number is NOT valid
  if ($utils.isDefined(locations_invalid_numbers)) {
      if (locations_invalid_numbers.length > 0) {
  
          Locations = Locations.filter(l => !$utils.isDefined(l.AllocationSequence) || !isNaN(Number(l.AllocationSequence))); //Replace locations with only valid records
  
          let invalid_numbers = locations_invalid_numbers.filter((value, index, array) => array.indexOf(value) === index);
  
          row_number = $grid.rows.length;
  
          for (let invalid_number of invalid_numbers) {
  
              let invalid_location_numbers = locations_invalid_numbers.filter(l => l === invalid_number);
  
              if (invalid_number === '') { invalid_number = '<blank>' }
  
              row_number += 1;
              row = await $grid.addRow({ Id: row_number });
              row.cells.import_status.displayControl.text = 'Error';
              row.cells.error.displayControl.text = `Allocation Sequence Value of [${invalid_number}] is not valid.`;
              row.cells.row_count.displayControl.text = invalid_location_numbers.length.toLocaleString();
          }
      }
  }
  
  locations_invalid_numbers = Locations.filter(l => $utils.isDefined(l.ChildFootprint) && isNaN(Number(l.ChildFootprint)))?.map(l => l.ChildFootprint); //A number is NOT valid
  if ($utils.isDefined(locations_invalid_numbers)) {
      if (locations_invalid_numbers.length > 0) {
  
          Locations = Locations.filter(l => !$utils.isDefined(l.ChildFootprint) || !isNaN(Number(l.ChildFootprint))); //Replace locations with only valid records
  
          let invalid_numbers = locations_invalid_numbers.filter((value, index, array) => array.indexOf(value) === index);
  
          row_number = $grid.rows.length;
  
          for (let invalid_number of invalid_numbers) {
  
              let invalid_location_numbers = locations_invalid_numbers.filter(l => l === invalid_number);
  
              if (invalid_number === '') { invalid_number = '<blank>' }
  
              row_number += 1;
              row = await $grid.addRow({ Id: row_number });
              row.cells.import_status.displayControl.text = 'Error';
              row.cells.error.displayControl.text = `Child Footprint Value of [${invalid_number}] is not valid.`;
              row.cells.row_count.displayControl.text = invalid_location_numbers.length.toLocaleString();
          }
      }
  }
  
  locations_invalid_numbers = Locations.filter(l => $utils.isDefined(l.ChildStackHeight) && isNaN(Number(l.ChildStackHeight)))?.map(l => l.ChildStackHeight); //A number is NOT valid
  if ($utils.isDefined(locations_invalid_numbers)) {
      if (locations_invalid_numbers.length > 0) {
  
          Locations = Locations.filter(l => !$utils.isDefined(l.ChildStackHeight) || !isNaN(Number(l.ChildStackHeight))); //Replace locations with only valid records
  
          let invalid_numbers = locations_invalid_numbers.filter((value, index, array) => array.indexOf(value) === index);
  
          row_number = $grid.rows.length;
  
          for (let invalid_number of invalid_numbers) {
  
              let invalid_location_numbers = locations_invalid_numbers.filter(l => l === invalid_number);
  
              if (invalid_number === '') { invalid_number = '<blank>' }
  
              row_number += 1;
              row = await $grid.addRow({ Id: row_number });
              row.cells.import_status.displayControl.text = 'Error';
              row.cells.error.displayControl.text = `Child Stack Height Value of [${invalid_number}] is not valid.`;
              row.cells.row_count.displayControl.text = invalid_location_numbers.length.toLocaleString();
          }
      }
  }
  
  locations_invalid_numbers = Locations.filter(l => $utils.isDefined(l.Height) && isNaN(Number(l.Height)))?.map(l => l.Height); //A number is NOT valid
  if ($utils.isDefined(locations_invalid_numbers)) {
      if (locations_invalid_numbers.length > 0) {
  
          Locations = Locations.filter(l => !$utils.isDefined(l.Height) || !isNaN(Number(l.Height))); //Replace locations with only valid records
  
          let invalid_numbers = locations_invalid_numbers.filter((value, index, array) => array.indexOf(value) === index);
  
          row_number = $grid.rows.length;
  
          for (let invalid_number of invalid_numbers) {
  
              let invalid_location_numbers = locations_invalid_numbers.filter(l => l === invalid_number);
  
              if (invalid_number === '') { invalid_number = '<blank>' }
  
              row_number += 1;
              row = await $grid.addRow({ Id: row_number });
              row.cells.import_status.displayControl.text = 'Error';
              row.cells.error.displayControl.text = `Height Value of [${invalid_number}] is not valid.`;
              row.cells.row_count.displayControl.text = invalid_location_numbers.length.toLocaleString();
          }
      }
  }
  
  locations_invalid_numbers = Locations.filter(l => $utils.isDefined(l.Length) && isNaN(Number(l.Length)))?.map(l => l.Length); //A number is NOT valid
  if ($utils.isDefined(locations_invalid_numbers)) {
      if (locations_invalid_numbers.length > 0) {
  
          Locations = Locations.filter(l => !$utils.isDefined(l.Length) || !isNaN(Number(l.Length))); //Replace locations with only valid records
  
          let invalid_numbers = locations_invalid_numbers.filter((value, index, array) => array.indexOf(value) === index);
  
          row_number = $grid.rows.length;
  
          for (let invalid_number of invalid_numbers) {
  
              let invalid_location_numbers = locations_invalid_numbers.filter(l => l === invalid_number);
  
              if (invalid_number === '') { invalid_number = '<blank>' }
  
              row_number += 1;
              row = await $grid.addRow({ Id: row_number });
              row.cells.import_status.displayControl.text = 'Error';
              row.cells.error.displayControl.text = `Length Value of [${invalid_number}] is not valid.`;
              row.cells.row_count.displayControl.text = invalid_location_numbers.length.toLocaleString();
          }
      }
  }
  
  locations_invalid_numbers = Locations.filter(l => $utils.isDefined(l.PickSequence) && isNaN(Number(l.PickSequence)))?.map(l => l.PickSequence); //A number is NOT valid
  if ($utils.isDefined(locations_invalid_numbers)) {
      if (locations_invalid_numbers.length > 0) {
  
          Locations = Locations.filter(l => !$utils.isDefined(l.PickSequence) || !isNaN(Number(l.PickSequence))); //Replace locations with only valid records
  
          let invalid_numbers = locations_invalid_numbers.filter((value, index, array) => array.indexOf(value) === index);
  
          row_number = $grid.rows.length;
  
          for (let invalid_number of invalid_numbers) {
  
              let invalid_location_numbers = locations_invalid_numbers.filter(l => l === invalid_number);
  
              if (invalid_number === '') { invalid_number = '<blank>' }
  
              row_number += 1;
              row = await $grid.addRow({ Id: row_number });
              row.cells.import_status.displayControl.text = 'Error';
              row.cells.error.displayControl.text = `Pick Sequence Value of [${invalid_number}] is not valid.`;
              row.cells.row_count.displayControl.text = invalid_location_numbers.length.toLocaleString();
          }
      }
  }
  
  locations_invalid_numbers = Locations.filter(l => $utils.isDefined(l.PutawaySequence) && isNaN(Number(l.PutawaySequence)))?.map(l => l.PutawaySequence); //A number is NOT valid
  if ($utils.isDefined(locations_invalid_numbers)) {
      if (locations_invalid_numbers.length > 0) {
  
          Locations = Locations.filter(l => !$utils.isDefined(l.PutawaySequence) || !isNaN(Number(l.PutawaySequence))); //Replace locations with only valid records
  
          let invalid_numbers = locations_invalid_numbers.filter((value, index, array) => array.indexOf(value) === index);
  
          row_number = $grid.rows.length;
  
          for (let invalid_number of invalid_numbers) {
  
              let invalid_location_numbers = locations_invalid_numbers.filter(l => l === invalid_number);
  
              if (invalid_number === '') { invalid_number = '<blank>' }
  
              row_number += 1;
              row = await $grid.addRow({ Id: row_number });
              row.cells.import_status.displayControl.text = 'Error';
              row.cells.error.displayControl.text = `Putaway Sequence Value of [${invalid_number}] is not valid.`;
              row.cells.row_count.displayControl.text = invalid_location_numbers.length.toLocaleString();
          }
      }
  }
  
  locations_invalid_numbers = Locations.filter(l => $utils.isDefined(l.Weight) && isNaN(Number(l.Weight)))?.map(l => l.Weight); //A number is NOT valid
  if ($utils.isDefined(locations_invalid_numbers)) {
      if (locations_invalid_numbers.length > 0) {
  
          Locations = Locations.filter(l => !$utils.isDefined(l.Weight) || !isNaN(Number(l.Weight))); //Replace locations with only valid records
  
          let invalid_numbers = locations_invalid_numbers.filter((value, index, array) => array.indexOf(value) === index);
  
          row_number = $grid.rows.length;
  
          for (let invalid_number of invalid_numbers) {
  
              let invalid_location_numbers = locations_invalid_numbers.filter(l => l === invalid_number);
  
              if (invalid_number === '') { invalid_number = '<blank>' }
  
              row_number += 1;
              row = await $grid.addRow({ Id: row_number });
              row.cells.import_status.displayControl.text = 'Error';
              row.cells.error.displayControl.text = `Weight Value of [${invalid_number}] is not valid.`;
              row.cells.row_count.displayControl.text = invalid_location_numbers.length.toLocaleString();
          }
      }
  }
  
  locations_invalid_numbers = Locations.filter(l => $utils.isDefined(l.Width) && isNaN(Number(l.Width)))?.map(l => l.Width); //A number is NOT valid
  if ($utils.isDefined(locations_invalid_numbers)) {
      if (locations_invalid_numbers.length > 0) {
  
          Locations = Locations.filter(l => !$utils.isDefined(l.Width) || !isNaN(Number(l.Width))); //Replace locations with only valid records
  
          let invalid_numbers = locations_invalid_numbers.filter((value, index, array) => array.indexOf(value) === index);
  
          row_number = $grid.rows.length;
  
          for (let invalid_number of invalid_numbers) {
  
              let invalid_location_numbers = locations_invalid_numbers.filter(l => l === invalid_number);
  
              if (invalid_number === '') { invalid_number = '<blank>' }
  
              row_number += 1;
              row = await $grid.addRow({ Id: row_number });
              row.cells.import_status.displayControl.text = 'Error';
              row.cells.error.displayControl.text = `Width Value of [${invalid_number}] is not valid.`;
              row.cells.row_count.displayControl.text = invalid_location_numbers.length.toLocaleString();
          }
      }
  }
  
  $grid.topToolbar.linecount.control.label = 'Parent validation...';
  
  let locations_without_parents = Locations.filter(l => !$utils.isDefined(l.Parent)).map(l => l.Name); //No parents specified
  if ($utils.isDefined(locations_without_parents)) {
      if (locations_without_parents.length > 0) {
  
          Locations = Locations.filter(l => $utils.isDefined(l.Parent)); //Replace locations with only valid records
  
          row_number = $grid.rows.length;
          row_number += 1;
          row = await $grid.addRow({ Id: row_number });
          row.cells.import_status.displayControl.text = 'Error';
          row.cells.error.displayControl.text = `Locations do not have a parent.`;
          row.cells.row_count.displayControl.text = locations_without_parents.length.toLocaleString();
  
      }
  }
  
  let locations_parents_match_location = Locations.filter(l => l.Parent === l.Name).map(l => l.Name); //A location cannot be its own parent
  if ($utils.isDefined(locations_parents_match_location)) {
      if (locations_parents_match_location.length > 0) {
  
          Locations = Locations.filter(l => l.Parent !== l.Name); //Replace locations with only valid records
  
          row_number = $grid.rows.length;
          row_number += 1;
          row = await $grid.addRow({ Id: row_number });
          row.cells.import_status.displayControl.text = 'Error';
          row.cells.error.displayControl.text = `Locations cannot be their own parent.`;
          row.cells.row_count.displayControl.text = locations_parents_match_location.length.toLocaleString();
  
      }
  }
  
  let parent_locations: string[];
  let location_names: string[];
  
  //Get the parents that are not in the file per warehouse
  warehouses = Locations.map(l => l.Warehouse);
  warehouses = warehouses.filter((value, index, array) => array.indexOf(value) === index);
  
  for (let warehouse of warehouses) {
  
      parent_locations = Locations.filter(l => l.Warehouse === warehouse).map(l => l.Parent);
      location_names = Locations.filter(l => l.Warehouse === warehouse).map(l => l.Name);
  
      parent_locations = parent_locations.filter((value, index, array) => array.indexOf(value) === index);
  
      let parents_not_on_file = parent_locations.filter(p => location_names.indexOf(p) === -1);
      if ($utils.isDefined(parents_not_on_file)) {
          if (parents_not_on_file.length > 0) {
  
              let zones = ((await $datasources.ExcelLocationImport.ds_get_locations.get({ typeIds: [1, 2], warehouseName: warehouse })).result).map(z => z.Name);
  
              if ($utils.isDefined(zones)) {
                  if (zones.length > 0) {
  
                      //Parents not found on the DB either
                      parents_not_on_file = parents_not_on_file.filter(p => zones.indexOf(p) === -1);
  
                      if ($utils.isDefined(parents_not_on_file)) {
                          if (parents_not_on_file.length > 0) {
  
                              row_number = $grid.rows.length;
  
                              for (let parent of parents_not_on_file) {
  
                                  let invalid_parents = Locations.filter(l => l.Parent === parent).map(l => l.Name);
  
                                  row_number += 1;
                                  row = await $grid.addRow({ Id: row_number });
                                  row.cells.import_status.displayControl.text = 'Error';
                                  row.cells.error.displayControl.text = `Parent Location [${parent}] does not exist.`;
                                  row.cells.row_count.displayControl.text = invalid_parents.length.toLocaleString();
                              }
                              Locations = Locations.filter(l => parents_not_on_file.indexOf(l.Parent) === -1); //Replace locations with only valid records
                          }
                      }
                  }
              }
          }
      }
  }
  
  
  $grid.topToolbar.linecount.control.label = 'Location mixing rules validation...';
  
  //Validate mixingRules
  let mixingRules = ((await $datasources.ExcelLocationImport.ds_get_mixingrestrictions_by_names.get({})).result)?.map(t => t.Name);
  let locations_invalid_mixing_restriction = Locations.filter(l => $utils.isDefined(l.MixingRestrictions) && mixingRules.indexOf(l.MixingRestrictions) === -1)?.map(l => l.MixingRestrictions); //Mixing Restriction is NOT valid
  
  if ($utils.isDefined(locations_invalid_mixing_restriction)) {
      if (locations_invalid_mixing_restriction.length > 0) {
  
          Locations = Locations.filter(l => mixingRules.indexOf(l.MixingRestrictions) > -1); //Replace locations with only valid records
  
          let invalid_stalocations_invalid_mixing_restrictiontuses = locations_invalid_mixing_restriction.filter((value, index, array) => array.indexOf(value) === index);
  
          row_number = $grid.rows.length;
  
          for (let invalid_restriction of invalid_stalocations_invalid_mixing_restrictiontuses) {
  
              let locations_invalid_mixing_restrictions = locations_invalid_mixing_restriction.filter(l => l === invalid_restriction);
  
              if (invalid_restriction === '') { invalid_restriction = '<blank>' }
  
              row_number += 1;
              row = await $grid.addRow({ Id: row_number });
              row.cells.import_status.displayControl.text = 'Error';
              row.cells.error.displayControl.text = `Mixing rule [${invalid_restriction}] is not valid.`;
              row.cells.row_count.displayControl.text = locations_invalid_mixing_restrictions.length.toLocaleString();
          }
      }
  }
  
  
  $grid.topToolbar.linecount.control.label = 'Location storage categories validation...';
  
  //Validate Storage Categories
  let storageCategories = ((await $datasources.ExcelLocationImport.ds_get_storagecategories_by_lookupcode.get({})).result)?.map(t => t.LookupCode);
  let locations_invalid_category = Locations.filter(l => $utils.isDefined(l.StorageCategory) && storageCategories.indexOf(l.StorageCategory) === -1)?.map(l => l.StorageCategory); //Status is NOT valid
  
  if ($utils.isDefined(locations_invalid_category)) {
      if (locations_invalid_category.length > 0) {
  
          Locations = Locations.filter(l => statuses.indexOf(l.StorageCategory) > -1); //Replace locations with only valid records
  
          let invalid_categories = locations_invalid_category.filter((value, index, array) => array.indexOf(value) === index);
  
          row_number = $grid.rows.length;
  
          for (let invalid_category of invalid_categories) {
  
              let invalid_location_categories = locations_invalid_category.filter(l => l === invalid_category);
  
              if (invalid_category === '') { invalid_category = '<blank>' }
  
              row_number += 1;
              row = await $grid.addRow({ Id: row_number });
              row.cells.import_status.displayControl.text = 'Error';
              row.cells.error.displayControl.text = `Storage category [${invalid_category}] is not valid.`;
              row.cells.row_count.displayControl.text = invalid_location_categories.length.toLocaleString();
          }
      }
  }
  
  $grid.topToolbar.linecount.control.label = 'Duplicates validation...';
  
  warehouses = Locations.map(l => l.Warehouse);
  warehouses = warehouses.filter((value, index, array) => array.indexOf(value) === index);
  
  for (let warehouse of warehouses) {
  
      location_names = Locations.filter(l => l.Warehouse === warehouse).map(l => l.Name);
      let duplicate_locations = location_names.filter((value, index, array) => array.indexOf(value) !== index); //Get duplicates
  
      if ($utils.isDefined(duplicate_locations)) {
          if (duplicate_locations.length > 0) {
  
              let duplicates = Locations.filter(l => duplicate_locations.indexOf(l.Name) > -1).map(l => l.Name);
              Locations = Locations.filter(l => duplicate_locations.indexOf(l.Name) === -1) //Replace locations with only valid records
  
              row_number = $grid.rows.length;
              row_number += 1;
              row = await $grid.addRow({ Id: row_number });
              row.cells.import_status.displayControl.text = 'Error';
              row.cells.error.displayControl.text = `Duplicate location records found for [${warehouse}].`;
              row.cells.row_count.displayControl.text = duplicates.length.toLocaleString();
          }
      }
  }
  
  //The count of valid records
  $grid.rows[0].cells.row_count.displayControl.text = Locations.length.toLocaleString();
  
  $grid.topToolbar.linecount.control.label = 'Prepraring Import...';
  
  if (Locations?.length > 0) {
  
      warehouses = Locations.map(l => l.Warehouse);
      warehouses = warehouses.filter((value, index, array) => array.indexOf(value) === index);
  
      let typeIds = (await $datasources.ExcelLocationImport.ds_get_locationtypes_by_names.get({})).result;
      let statusIds = (await $datasources.ExcelLocationImport.ds_get_locationstatuses_by_names.get({})).result;
      let measurementIds = (await $datasources.ExcelLocationImport.ds_measurement_units_dd.get({})).result;
      let mixingruleIds = (await $datasources.ExcelLocationImport.mixing_rule_selector.get({})).result;
      let storageCategoryIds = (await $datasources.ExcelLocationImport.ds_storage_rules_dd.get({})).result;
  
      let processing_index: number;
  
      for (let warehouse of warehouses) {
  
          let warehouse_time = new Date();
          let locations_with_level: { locations: typeof Locations, level: number }[] = [];
  
          let warehouses_info = (await $datasources.ExcelLocationImport.ds_get_warehouses_by_names.get({ warehouseNames: [warehouse] }))?.result;
          let warehouseId: number = warehouses_info ? warehouses_info[0]?.Id : null;
  
          //Get locations for this warehouse
          let WarehouseLocations = Locations.filter(l => l.Warehouse?.toUpperCase() === warehouse.toUpperCase());
          let LocationCount = WarehouseLocations?.length ?? 0;
          let ProcessedCount = 0;
          let SuccessCount = 0;
          let ErrorCount = 0;
  
          //Distinct
          let unique_list = [...new Set(WarehouseLocations.map(item => JSON.stringify({ Name: item.Name?.toUpperCase(), Parent: item.Parent?.toUpperCase() })))];
          let DistinctLocations: { Name: string, Parent: string }[] = unique_list.map(item => JSON.parse(item));
  
          let parents = DistinctLocations.map(l => l.Parent)
          parents = parents.filter(p => DistinctLocations.filter(l => l.Name === p)?.length > 0); //Only parents to create
          parents = parents.filter((value, index, array) => array.indexOf(value) === index); //Distinct
  
          let parents_with_level: { parent: string, level: number }[] = [];
  
          //Were checking how many levels deep is the parent location
          for (let parent of parents) {
  
              let start = [parent];
              let parent_level = 0;
  
              while (start?.length > 0) {
  
                  start = DistinctLocations.filter(l => start.indexOf(l.Parent) >= 0 && l.Parent !== l.Name)?.map(l => l.Name);
                  parent_level++;
              }
  
              parents_with_level.push({ parent: parent, level: parent_level })
          }
  
          let level: number = 0;
  
          //We want to import first the parent locations that have the most levels
          if (parents_with_level?.length > 0) {
  
              let parent_levels = parents_with_level.map(l => l.level);
  
              parent_levels = parent_levels.filter((value, index, array) => array.indexOf(value) === index); //Distinct
              parent_levels = parent_levels.sort((a, b) => b - a) //Descending
  
              for (let parent_level of parent_levels) {
  
                  level++;
  
                  let names = parents_with_level.filter(p => p.level === parent_level).map(p => p.parent);
                  let locations = WarehouseLocations.filter(l => names.indexOf(l.Name?.toUpperCase()) >= 0);
  
                  locations_with_level.push({
                      level: level,
                      locations: locations
                  })
  
                  WarehouseLocations = WarehouseLocations.filter(l => names.indexOf(l.Name?.toUpperCase()) === -1);
              }
          }
  
          //And last, the remaining locations
          if (WarehouseLocations?.length > 0) {
  
              level++;
  
              locations_with_level.push({
                  level: level,
                  locations: WarehouseLocations
              })
          }
  
          $grid.rows[0].cells.row_count.displayControl.text = LocationCount.toLocaleString();
          $grid.topToolbar.linecount.control.label = 'Starting Import...';
  
          for (let LocationsToImport of locations_with_level.map(l => l.locations)) {
  
              let start: number = 0;
              let LocationsSplit = LocationsToImport.slice(start, start + batch_size);
  
              while (LocationsSplit?.length > 0) {
  
                  row_number = $grid.rows.length;
                  row_number += 1;
                  row = await $grid.addRow({ Id: row_number });
                  row.cells.import_status.displayControl.text = 'Processing';
                  row.cells.error.displayControl.text = `Records processing for warehouse [${warehouse}].`;
                  row.cells.row_count.displayControl.text = LocationsSplit.length.toLocaleString();
  
                  processing_index = row_number - 1;
                  let processing_count = LocationsSplit.length;
                  let processing_time = new Date();
                  let percentage = Math.floor((ProcessedCount / LocationCount) * 100);
  
                  $grid.topToolbar.linecount.control.label = `Warehouse progress (${percentage}%)`;
  
                  ProcessedCount = ProcessedCount + LocationsSplit.length;
  
                  //Check if the location already exist
                  let location_names = LocationsSplit.map(l => l.Name);
                  let current_locations = ((await $datasources.ExcelLocationImport.ds_get_locations.get({ warehouseName: warehouse, names: location_names })).result).map(l => l.Name);
                  let locations_already_exist = location_names.filter(l => current_locations.indexOf(l) > -1);
  
                  if ($utils.isDefined(locations_already_exist)) {
                      if (locations_already_exist.length > 0) {
  
                          LocationsSplit = LocationsSplit.filter(l => locations_already_exist.indexOf(l.Name) === -1) //Replace locations with only valid records
                          SuccessCount = SuccessCount + locations_already_exist.length;
  
                          row_number = $grid.rows.length;
                          row_number += 1;
                          row = await $grid.addRow({ Id: row_number });
                          row.cells.import_status.displayControl.text = 'Skipped';
                          row.cells.error.displayControl.text = `Skipping ${locations_already_exist.length} locations that already exist for warehouse [${warehouse}].`;
                          row.cells.row_count.displayControl.text = locations_already_exist.length.toLocaleString();
  
                          processing_count = processing_count - locations_already_exist.length;
                          $grid.rows[processing_index].cells.row_count.displayControl.text = processing_count.toLocaleString();
                          $grid.rows[processing_index].cells.error.displayControl.text = `Processing records for warehouse [${warehouse}]. (Elapsed ${(((new Date()).getTime() - processing_time.getTime()) / 1000)} sec)`;
                      }
                  }
  
                  if (LocationsSplit.length > 0) {
  
                      let parent_names = LocationsSplit.map(l => l.Parent).filter((value, index, array) => array.indexOf(value) === index);
                      let locationIds = (await $datasources.ExcelLocationImport.ds_get_locations.get({ warehouseName: warehouse, names: parent_names })).result;
                      let license_plates = LocationsSplit.filter(s => s.IsLoose_YN === 'Y' && s.Type === 'Location');
                      let split_time = new Date();
                      let size: number = 0;
  
                      row_number = $grid.rows.length;
                      row_number += 1;
  
                      let entities: {
                          set?: string;
                          keys?: {
                              name?: string;
                              value?: any;
                          }[];
                          method?: string;
                          properties?: any;
                      }[] = [];
  
                      try {
  
                          size = LocationsSplit.length;
  
                          let newIdCeiling = (await $flows.Utilities.reserve_batchId_flow({ entity: "LocationContainer", batchSize: size })).newIdCeiling;
  
                          let payload = LocationsSplit.map(l => {
                              return {
                                  method: 'POST',
                                  set: 'LocationContainers',
                                  properties: {
                                      "Id": newIdCeiling - LocationsSplit.indexOf(l),
                                      "WarehouseId": warehouseId,
                                      "ParentId": locationIds.find(p => p.Name === l.Parent)?.Id,
                                      "StatusId": statusIds.find(s => s.Name === l.Status)?.Id,
                                      "Depth": 1,
                                      "Path": '/',
                                      "Name": l.Name,
                                      "TypeId": typeIds.find(f => f.Name === l.Type).Id,
                                      "IsLoose": l.IsLoose_YN === 'Y' ? true : false,
                                      "EligibleForAllocation": l.EligibleForAllocation_YN === 'Y' ? true : false,
                                      "Enabled": true,
                                      "AllowInventoryIfNotActive": true,
                                      "GlobalAllocationSequence": l.AllocationSequence ? Number(l.AllocationSequence) : null,
                                      "GlobalPickSequence": l.PickSequence ? Number(l.PickSequence) : null,
                                      "GlobalPutawaySequence": l.PutawaySequence ? Number(l.PutawaySequence) : null,
                                      "AllocationSequence": l.AllocationSequence ? Number(l.AllocationSequence) : null,
                                      "PickSequence": l.PickSequence ? Number(l.PickSequence) : null,
                                      "PutawaySequence": l.PutawaySequence ? Number(l.PutawaySequence) : null,
                                      "ChildFootprint": l.ChildFootprint ? Number(l.ChildFootprint) : null,
                                      "ChildStackHeight": l.ChildStackHeight ? Number(l.ChildStackHeight) : null,
                                      "Length": l.Length ? Number(l.Length) : null,
                                      "Width": l.Width ? Number(l.Width) : null,
                                      "Height": l.Height ? Number(l.Height) : null,
                                      "DimensionUomId": measurementIds.find(m => m.Short_name === l.DimensionsUom)?.Id,
                                      "WeightCapacity": l.Weight ? Number(l.Weight) : null,
                                      "WeightUomId": measurementIds.find(m => m.Short_name === l.WeightUom)?.Id,
                                      // "VolumeCapacity": null,
                                      // "VolumeUomId": null,
                                      "ManufacturingLineFlag": false,
                                      "RestrictToReplenishmentMaterials": false,
                                      "PurgeAddedInventory": false,
                                      "IsPrimaryPick": l.IsPrimary_YN === 'Y' ? true : false,
                                      "SkipCycleCount": false,
                                      "EligibleForManufacturingFeedback": false,
                                      "IsManufacturingStagingLocation": false,
                                      "AllowMoveTaskCreation": false,
                                      "DisableNonPreferredLocationAlertCreation": false,
                                      "SkipValidationRules": l.SkipValidation_YN === 'Y' ? true : false,
                                      "BreakInventoryToBasePackaging": false,
                                      "ConfirmInventoryDeletion": false,
                                      "EligibleForScaleTicket": false,
                                      "SkipAfterPickingCountBack": false,
                                      "AutoSelectCountOnCountBack": false,
                                      "MobileForceUserCountBack": false,
                                      "IsPackageVerification": false,
                                      "IsDynamicPrimaryPick": false,
                                      "MixingRuleId": mixingruleIds.find(m => m.Name === l.MixingRestrictions)?.Id,
                                      "StorageCategoryId": storageCategoryIds.find(s => s.LookupCode === l.StorageCategory)?.Id,
                                      "IsUsedForReturns": false
                                  }
                              }
                          });
  
                          //Add missing fields for versions
                          const versionChecks = [
                              {
                                  version: 6213, properties: {
                                      IsUsedForReturns: false
                                  }
                              },
                              {
                                  version: 6753, properties: {
                                      IsPackageVerification: false,
                                      IsDynamicPrimaryPick: false
                                  }
                              },
                              {
                                  version: 7178, properties: {
                                      AllowOnlyCLPs: false
                                  }
                              }
                          ];
  
                          versionChecks.forEach(check => {
                              if ($grid.vars.footprintVersion >= check.version) {
                                  payload.forEach(p => p.properties = { ...check.properties, ...p.properties })
                              }
                          });
  
                          entities = payload;
  
                          if (license_plates.length > 0) {
  
                              size = license_plates.length;
                              newIdCeiling = (await $flows.Utilities.reserve_batchId_flow({ entity: "LicensePlate", batchSize: size })).newIdCeiling;
  
                              const license_plate_payload = license_plates.map(l => {
                                  return {
                                      method: 'POST',
                                      set: 'LicensePlates',
                                      properties: {
                                          "Id": newIdCeiling - license_plates.indexOf(l),
                                          "WarehouseId": warehouseId,
                                          "LocationId": payload.filter(p => p.properties.Name === l.Name)[0].properties.Id,
                                          "TypeId": 3,
                                          "StatusId": 1,
                                          "LookupCode": payload.filter(p => p.properties.Name === l.Name)[0].properties.Name,
                                          "Archived": false
                                      }
                                  }
                              });
                              entities = entities.concat(license_plate_payload);
                          }
  
                          let tries = $grid.vars.Retry;
  
                          if (tries <= 0) { tries = 1 }
  
                          while (tries > 0) {
  
                              tries--;
  
                              let result = (await $flows.Utilities.crud_batch_request_flow({ entities: entities }));
  
                              if ($utils.isDefined(result.reasons)) {
  
                                  let error_message = result.reasons.join(' ,');
                                  if (tries == 0) { throw new Error(error_message) } else {
  
                                      row.cells.error.displayControl.text = `Attempting to import ${LocationsSplit?.length} locations again. (${ProcessedCount} of ${LocationCount}). (${(((new Date()).getTime() - split_time.getTime()) / 1000)} sec)`;
  
                                      $flows.Utilities.logs_write({
                                          input: [{
                                              level: 2,
                                              message: error_message,
                                              notes: JSON.stringify({
                                                  tries: tries,
                                                  batch_size: batch_size,
                                                  entities: entities
                                              }),
                                              process_name: 'on_excel_import_batch'
                                          }],
                                          criteria: { application_name: 'ExcelLocationImport' }
                                      })
                                  }
                              } else {
                                  tries = 0;
                                  SuccessCount = SuccessCount + LocationsSplit.length;
                                  row = await $grid.addRow({ Id: row_number });
                                  row.cells.import_status.displayControl.text = 'Completed';
                                  row.cells.error.displayControl.text = `Success Importing Locations (${SuccessCount} of ${LocationCount}). (${(((new Date()).getTime() - split_time.getTime()) / 1000)} sec)`;
                                  row.cells.row_count.displayControl.text = LocationsSplit.length.toLocaleString();
                              }
                          }
                      }
                      catch (error) {
  
                          ErrorCount = ErrorCount + LocationsSplit.length;
  
                          let targetError = error;
                          while ($utils.isDefined(targetError?.error)) { targetError = targetError.error }
                          if (!$utils.isDefined(targetError?.message)) { targetError = { "message": `Uncaught exception. ${JSON.stringify(targetError)}` } }
  
                          row = await $grid.addRow({ Id: row_number });
  
                          let error_message = `Error Importing Locations (${ErrorCount} of ${LocationCount}). ${targetError.message} (${(((new Date()).getTime() - split_time.getTime()) / 1000)} sec)`
                          row.cells.import_status.displayControl.text = 'Error';
                          row.cells.error.displayControl.text = error_message;
                          row.cells.row_count.displayControl.text = LocationsSplit.length.toLocaleString();
  
                          $flows.Utilities.logs_write({
                              input: [{
                                  level: 3,
                                  message: error_message,
                                  notes: JSON.stringify(entities),
                                  process_name: 'on_excel_import_batch'
                              }],
                              criteria: { application_name: 'ExcelLocationImport' }
                          })
                      }
                      $grid.rows[processing_index].cells.error.displayControl.text = `Processing records for warehouse [${warehouse}]. (Elapsed ${(((new Date()).getTime() - processing_time.getTime()) / 1000)} sec)`;
                  }
  
                  start = start + batch_size;
                  LocationsSplit = LocationsToImport.slice(start, start + batch_size);
              }
          } //End locations with level
  
          let success_message = `Finished importing ${SuccessCount} records for warehouse [${warehouse}]. (${(((new Date()).getTime() - warehouse_time.getTime()) / 1000)} sec)`;
  
          row = await $grid.addRow({ Id: row_number });
          row.cells.import_status.displayControl.text = 'Finished';
          row.cells.error.displayControl.text = success_message
          row.cells.row_count.displayControl.text = SuccessCount.toLocaleString();
  
          $flows.Utilities.logs_write({
              input: [{
                  level: 0,
                  message: success_message,
                  notes: JSON.stringify({
                      batch_size: batch_size
                  }),
                  process_name: 'on_excel_import_batch'
              }],
              criteria: { application_name: 'ExcelLocationImport' }
          })
      } //End warehouse
  }
  
  /* functions */
  
  function validate_string_array(candidates: any) {
      let output: string[];
      output = [];
      if ($utils.isDefined(candidates)) {
          for (let candidate of candidates) {
              if (typeof candidate === "number") {
                  output.push(candidate.toString());
              } else {
                  output.push(candidate);
              }
          }
      }
      return output;
  }
  function validate_string_value(candidate: any) {
      let output: string;
      if ($utils.isDefined(candidate)) {
          if (typeof candidate === "number") {
              output = candidate.toString();
          } else {
              output = candidate;
          }
      }
      return output;
  }
  }
  on_excel_import_load(event = null) {
    return this.on_excel_import_loadInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_excel_import_loadInternal(
    $grid: ExcelLocationImport_excel_location_import_gridComponent,
  
    $shell: ExcelLocationImport_ShellService,
    $datasources: ExcelLocationImport_DatasourceService,
    $flows: ExcelLocationImport_FlowService,
    $reports: ExcelLocationImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelLocationImport_OperationService,
    $utils: UtilsService,
    $context: ExcelLocationImport_excel_location_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelLocationImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 08/16/2024
  
  await $grid.refresh();
  
  const wb = $event;
  const wsname = wb.SheetNames[0];
  const ws = wb.Sheets[wsname];
  
  $grid.canEdit = false;
  $grid.topToolbar.linecount.hidden = false;
  $grid.topToolbar.linecount.control.icon = "icon datex-default-spinner";
  $grid.topToolbar.linecount.control.label = 'Extracting Data..';
  
  let Locations = $utils.excel.sheet_to_json<{
      Warehouse: string,
      Parent: string,
      Name: string,
      Type: string,
      Status: string,
      IsLoose_YN: string,
      IsPrimary_YN: string,
      EligibleForAllocation_YN: string,
      Length: string,
      Width: string,
      Height: string,
      DimensionsUom: string,
      Weight: string,
      WeightUom: string,
      ChildFootprint: string,
      ChildStackHeight: string,
      SkipValidation_YN: string,
      PickSequence: string,
      AllocationSequence: string,
      PutawaySequence: string,
      MixingRestrictions: string, 
      StorageCategory: string
  
  }>(ws);
  
  if ($utils.isDefined(Locations)) {
  
      $grid.vars.Locations = Locations;
  
      //If there are more than 100 records use the batch flow
      if (Locations.length >= $grid.filters.batch_size.control.value) {
          await $grid.on_excel_import_batch();
      } else {
          await $grid.on_excel_import_individual();
      };
  
  };
  
  $grid.topToolbar.linecount.hidden = true;
  }
  //#endregion private flows

  async $importExcel(fileInput: HTMLInputElement) {
    if(fileInput.files?.length !== 1) {
      throw new Error('Cannot import multiple files');
    }
    const file = fileInput.files[0];
    if(file.size > 15 * 1000 * 1000) {
      throw new Error('Cannot import a file with size greater than 15MB');
    }
    const reader: FileReader = new FileReader();
    reader.onload = async (e: ProgressEvent<FileReader>) => {
      const ab: ArrayBuffer = e.target?.result as ArrayBuffer;
      const wb: WorkBook = readExcelFile(ab);
      await this.on_excel_import_load(wb);
    };
    reader.readAsArrayBuffer(file);
    fileInput.value = '';
  }

  async $exportExcel() {
    const wb: WorkBook = excelUtils.book_new();

    await this.on_excel_export(wb);

    writeExcelFile(wb, 'ExcelLocationImport_excel_location_import_gridComponent_export.xlsx');
  }
 
  close() {
    this.$finish.emit();
  }
}
